// import React, { useState, useRef, useEffect, useContext } from 'react'
// import ReactToPrint from "react-to-print";
// import print from "./images/icons/icons8-print-100.png"
// import ss from './images/login/ss_Logo.png'
// import close from './images/Inventory/close (1).png'
// import { DBContext } from './DBContext'
// import { ToastContainer, toast } from 'react-toastify';
// import { useLocation, useNavigate } from 'react-router-dom'
// // import {ipcRenderer} from 'electron'
// import io from 'socket.io-client';

// function PrintBill({ onClose, tableNo, area_id, table, billNo,
//     previousSelectedItems, toIncludeAddonsToPrint, total, orderToKot }) {

//     const api_base_url = process.env.REACT_APP_API_BASE_URL

//     const { logginedDB, customerCode, userType, companyDetails, handleGetCompanyDetails } = useContext(DBContext);
//     const isElectron = navigator.userAgent.toLowerCase().includes('electron');
//     const navigate = useNavigate(null)

//     async function convertImageToBase64(url) {
//         const response = await fetch(url);
//         const blob = await response.blob();
//         return new Promise((resolve) => {
//             const reader = new FileReader();
//             reader.onloadend = () => resolve(reader.result.split(',')[1]);
//             reader.readAsDataURL(blob);
//         });
//     }
//     const logoSrc = `data:image/png;base64,${convertImageToBase64(ss)}`;
//     // // console.log(logoSrc);

//     function getCurrentDate() {
//         const today = new Date();
//         const day = String(today.getDate()).padStart(2, '0');
//         const month = String(today.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
//         const year = today.getFullYear();
//         return `${day}/${month}/${year}`;
//     }

//     function getCurrentTime() {
//         const today = new Date();
//         const hours = String(today.getHours()).padStart(2, '0');
//         const minutes = String(today.getMinutes()).padStart(2, '0');
//         return `${hours}:${minutes}`;
//     }

//     useEffect(() => {
//         // Connect to the WebSocket server
//         const socket = io(api_base_url, {
//             transports: ['websocket'], // Force WebSocket to avoid fallback issues
//         });

//         // Avoid adding multiple listeners
//         socket.on('updateCompany', handleGetCompanyDetails);

//         return () => {
//             socket.off('updateCompany', handleGetCompanyDetails);
//             socket.disconnect();
//         };
//     }, []);

//     const printRef = useRef(null);

//     // const handlePrintBill = async () => {
//     //     try {
//     //         // Get available printers
//     //         const printers = await window.electron.getPrinters();
//     //         // console.log('Available printers:', printers);
//     //         // console.log(await window.electron.getPrinters());
//     //         // Find the best matching printer
//     //         const printerName = printers.find(p =>
//     //             p.name.includes('POS-58') || p.name.includes('58mm') || p.isDefault
//     //         )?.name;

//     //         if (!printerName) {
//     //             throw new Error('No suitable printer found');
//     //         }

//     //         // console.log('Using printer:', printerName);

//     //         // Get HTML content and ensure proper formatting
//     //         const htmlContent = `
//     //             <div style="width:58mm; font-family:'Courier New'; font-size:10pt; border-bottom: 1px dashed #000; border-top: 1px dashed #000;">
//     //                 ${printRef.current.innerHTML}
//     //                 <div style="text-align:center; margin-top:3mm; margin-bottom:2mm; font-size:10pt">Thank You Visit Again</div>
//     //             </div>
//     //         `;
//     //         // console.log("printRef.current.innerHTML", printRef.current.innerHTML);

//     //         // First try direct printing
//     //         const printResult = await window.electron.printContent({
//     //             html: htmlContent,
//     //             printerName,
//     //             widthMM: 58,
//     //             heightMM: 0 // Initial height, will adjust to content
//     //         });
//     //         // console.log("printResult", printResult);

//     //         if (!printResult.success) {
//     //             throw new Error(printResult.error || 'Direct print failed');
//     //         }

//     //         // Handle successful print
//     //         const response = await fetch(`${api_base_url}/printBill/${logginedDB}/${tableNo}/${area_id}/${table}/${billNo}`, {
//     //             method: 'POST'
//     //         });

//     //         if (response.ok) {
//     //             const data = await response.json();
//     //             toast.success("Printed successfully!");
//     //             if (data.runningKotIsThere) {
//     //                 onClose(false);
//     //             } else {
//     //                 navigate('/TableView');
//     //             }
//     //         }
//     //     } catch (error) {
//     //         console.error("Print Error:", error);
//     //         toast.error(`Print failed: ${error.message}`);
//     //     }
//     // };

//     const handlePrintBill = async () => {
//         try {
//             const printers = await window.electron.getPrinters();
//             // console.log('Available printers:', printers);
//             const printerName = printers.find(p =>
//                 p.name.includes('POS-58') || p.name.includes('58mm') || p.isDefault
//             )?.name;

//             if (!printerName) {
//                 throw new Error('No suitable printer found');
//             }

//             // console.log('Using printer:', printerName);

//             // Embed print-specific CSS
//             const printStyles = `
//             <style>
//                 @media print {
//                     .printButton {
//                         display: none !important;
//                     }
//                     .printCustomClass {
//                         width: 58mm !important;
//                         font-size: 15px !important;
//                         margin: 0 !important;
//                         font-family: Arial, sans-serif !important;
//                         color: #000 !important;
//                     }
//                     .printCustomClassContainer {
//                         font-size: 1em !important;
//                         font-weight: 500 !important;
//                         padding: 10px !important;
//                         font-family: Arial, sans-serif !important;
//                     }
//                     .printCustomClassContainerInfo {
//                         font-size: 1em !important;
//                         font-family: Arial, sans-serif !important;
//                     }
//                     .printCustomClassContainerTable {
//                         font-size: 1em !important;
//                         font-family: Arial, sans-serif !important;
//                         border-bottom: 1px dashed #000 !important;
//                     }
//                     .printCustomClassContainerBorderY {
//                         border-bottom: 1px dashed #000 !important;
//                         border-top: 1px dashed #000 !important;
//                     }
//                     .paddingYForItems {
//                         padding-top: 0.25rem !important;
//                         padding-bottom: 0.25rem !important;
//                     }
//                     .gapY {
//                         gap: 0.25rem !important;
//                     }
//                     .fontSizeClass {
//                         font-family: Arial, sans-serif !important;
//                     }
//                     .highFontWeight {
//                         font-weight: 500 !important;
//                     }
//                     .headWeight {
//                         font-weight: 600 !important;
//                     }
//                     .printCustomClassContainerBorderTop {
//                         border-top: 1px dashed #000 !important;
//                     }
//                 }
//             </style>
//         `;

//             // Convert company logo to base64 if needed (optional, if the printer supports images)
//             const logoSrc = companyDetails.img; // Ensure this is a file path or base64 string accessible in Electron

//             // Construct the HTML content
//             const htmlContent = `
//             <html>
//                 <head>
//                     ${printStyles}
//                 </head>
//                 <body>
//                     <div style="width: 58mm; font-family: Arial, sans-serif; font-size: 10pt; border-bottom: 1px dashed #000; border-top: 1px dashed #000;">
//                         ${printRef.current.innerHTML}
//                         <div style="text-align: center; margin-top: 3mm; margin-bottom: 2mm; font-size: 10pt;">Thank You Visit Again</div>
//                     </div>
//                 </body>
//             </html>
//         `;
//             // console.log(printStyles,"\n*********\n",printRef)
//             // Print using Electron
//             const printResult = await window.electron.printContent({
//                 html: htmlContent,
//                 printerName,
//                 widthMM: 58,
//                 heightMM: 0 // Let the printer adjust height to content
//             });

//             if (!printResult.success) {
//                 throw new Error(printResult.error || 'Direct print failed');
//             }

//             // Handle successful print
//             const response = await fetch(`${api_base_url}/printBill/${logginedDB}/${tableNo}/${area_id}/${table}/${billNo}`, {
//                 method: 'POST'
//             });

//             if (response.ok) {
//                 const data = await response.json();
//                 toast.success("Printed successfully!");
//                 if (data.runningKotIsThere) {
//                     onClose(false);
//                 } else {
//                     navigate('/TableView');
//                 }
//             }
//         } catch (error) {
//             console.error("Print Error:", error);
//             toast.error(`Print failed: ${error.message}`);
//         }
//     };

//     const handleAfterPrint = () => {
//         //("e");
//     }
//     return (
//         <div className='relative w-[30rem] printCustomClass h-full flex items-end bg-[#fff] font-nunito' ref={printRef}>
//             <style>
//                 {`
//                     @media print {
//                         .printButton {
//                             display: none !important;
//                         }
//                         .printCustomClassContainer {
//                             padding: 5mm !important;
//                             gap: 1mm !important;
//                         }
//                         .paddingYForItems {
//                             padding-top: 1mm !important;
//                             padding-bottom: 1mm !important;
//                         }
//                         .gapY {
//                             gap: 1mm !important;
//                         }
//                         .printCustomClassContainerBorderTop {
//                             margin: 1mm 0 !important;
//                         }
//                         .printCustomClassContainerBorderY {
//                             padding: 1mm 0 !important;
//                         }
//                         .printCustomClassContainerTable {
//                             margin-bottom: 1mm !important;
//                         }
//                     }
//                 `}
//             </style>
//             <div className='absolute top-0 right-0 transform translate-x-full pl-2 flex flex-col gap-2 printButton'>
//                 <button className='p-2 cursor-pointer flex justify-center items-center bg-[#fff]' onClick={() => {
//                     onClose(false)
//                     if (orderToKot) {
//                         toast.success("Kot proccessed!", {
//                             className: 'custom-toast',
//                             bodyClassName: 'custom-toast-container',
//                             closeButtonClassName: 'custom-toast-close-button',
//                             onClose: () => { }
//                         });
//                         navigate('/TableView')
//                     }
//                 }}>
//                     <img className='w-[1.5rem]' src={close} alt="" />
//                 </button>
//                 <div className='bg-[#fff] flex justify-center items-center'>
//                     {isElectron ? (
//                         <>
//                         <button
//                             className="p-2 cursor-pointer hover:bg-[#cddcfc]"
//                             onClick={handlePrintBill}
//                         >
//                             <img className='w-[2rem]' src={print} alt="" />
//                         </button>
//                         </>
//                     ) : (
//                         <>
//                         <ReactToPrint
//                             trigger={() => (
//                                 <button
//                                     className="p-2 cursor-pointer hover:bg-[#cddcfc]"
//                                 // onClick={downloadPDF}
//                                 >
//                                     <img className='w-[2rem]' src={print} alt="" />
//                                 </button>
//                             )}
//                             content={() => printRef.current}
//                             onAfterPrint={handlePrintBill}
//                             onPrintError={() => {
//                                 alert("Print error! Please try again.");
//                             }}
//                         />
//                         </>
//                     )}
//                 </div>

//             </div>
//             {/* <div className='printCustomClassContainer w-full h-full flex flex-col p-10 gap-3 overflow-x-hidden overflow-y-auto customScroll'>
//                 <div className='w-full h-max flex justify-center items-center'>
//                     <img className='w-[5rem] h-[5rem]' src={companyDetails.img} alt="" />
//                 </div>
//                 <div className='w-full h-max flex flex-col justify-center items-center font-[600]'>
//                     <span className='fontSizeClass headWeight'>SHERDINE</span>
//                     <span className='fontSizeClass headWeight'>PERINTHALMANNA</span>
//                     <span className='fontSizeClass headWeight'>GST No M43010G195260</span>
//                 </div>
//                 <div className='w-full h-max flex gap-1 text-center justify-center items-center'>
//                     <div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
//                     <span className='fontSizeClass highFontWeight'>INVOICE</span>
//                     <div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
//                 </div>
//                 <div className='printCustomClassContainerInfo w-full h-max flex text-[.9rem]'>
//                     <div className='w-full flex flex-col text-left'>
//                         <span className='fontSizeClass'>Name : <span className='highFontWeight'>Gopu</span></span>
//                         <span className='fontSizeClass'>Table : <span className='highFontWeight'>#{tableNo}</span></span>
//                         <span className='fontSizeClass'>Cashier : <span className='highFontWeight'>biller</span></span>
//                     </div>
//                     <div className='w-max text-nowrap flex flex-col text-left'>
//                         <span className='fontSizeClass w-full flex gap-1'>
//                             <span className='w-full'>Invoice No : </span>
//                             <span className='w-max highFontWeight'>369</span>
//                         </span>
//                         <span className='fontSizeClass w-full flex gap-1'>
//                             <span className='w-full'>Time : </span>
//                             <span className='w-max highFontWeight'>{getCurrentTime()}</span>
//                         </span>
//                         <span className='fontSizeClass w-full flex gap-1'>
//                             <span className='w-full'>Date : </span>
//                             <span className='w-max highFontWeight'>{getCurrentDate()}</span>
//                         </span>
//                     </div>
//                 </div>
//                 <div className='w-full flex flex-col'>
//                     <div className='w-full printCustomClassContainerBorderY flex border-y-2 border-dashed border-[#b6b6b6] font-[600]'>
//                         <div className='w-6/12 py-2 fontSizeClass '>Item</div>
//                         <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Price</div>
//                         <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Qty</div>
//                         <div className='w-2/12 py-2 flex justify-end items-center fontSizeClass '>Total</div>
//                     </div>
//                     <div className='w-full flex flex-col pb-1 border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
//                         {previousSelectedItems.map((item, index) => {
//                             const hasVariant = item.variantName || null
//                             return (
//                                 <div key={index} className='w-full flex'>
//                                     <div className=' text-wrap w-6/12 py-2 fontSizeClass paddingYForItems'>{hasVariant ? `${item.productName} ${item.variantName}` : item.productName}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>₹ {item.rate}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>{item.quantity}</div>
//                                     <div className='w-2/12 py-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>₹ {item.quantity * item.rate}</div>
//                                 </div>
//                             )
//                         })}
//                         {toIncludeAddonsToPrint.map((addon, index) => {
//                             return (
//                                 <div key={index} className='w-full flex text-nowrap'>
//                                     <div className='w-6/12 py-2 fontSizeClass paddingYForItems'>{addon.addonName}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>₹ {addon.rate}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>{addon.quantity}</div>
//                                     <div className='w-2/12 py-2 flex justify-end items-center fontSizeClass paddingYForItems'>₹ {addon.quantity * addon.rate}</div>
//                                 </div>
//                             )
//                         })}
//                     </div>
//                 </div>
//                 <div className='w-full h-max flex flex-col gap-3 text-nowrap border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
//                     <div className='w-full flex flex-col gap-2 gapY'>
//                         <div className='w-full flex'>
//                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>Sub-Total :</span>
//                             <span className='w-4/12 flex justify-end items-center'>
//                                 <span className='w-full text-center'></span>
//                                 <span className='w-max pl-2 text-left fontSizeClass '>₹ {total}</span>
//                             </span>
//                         </div>
//                         <div className='w-full flex'>
//                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>CGST :</span>
//                             <span className='w-4/12 flex justify-end items-center'>
//                                 <span className='w-1/2 text-center fontSizeClass '>0%</span>
//                                 <span className='w-1/2 pl-2 text-right fontSizeClass '>₹ 0</span>
//                             </span>
//                         </div>
//                         <div className='w-full flex'>
//                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>SGST :</span>
//                             <span className='w-4/12 flex justify-end items-center'>
//                                 <span className='w-1/2 text-center fontSizeClass '>0%</span>
//                                 <span className='w-1/2 pl-2 text-right fontSizeClass '>₹ 0</span>
//                             </span>
//                         </div>
//                     </div>
//                     <div className='w-full flex text-nowrap'>
//                         <div className='w-1/2'></div>
//                         <div className='w-1/2 printCustomClassContainerBorderTop flex py-3 border-t-2 border-dashed border-[#b6b6b6]'>
//                             <span className='w-1/3 flex justify-end items-center font-[600] text-[1.05rem] fontSizeClass '>Total :</span>
//                             <span className='w-2/3 flex justify-end items-center'>
//                                 <span className='w-full text-center'></span>
//                                 <span className='w-max pl-2 text-left fontSizeClass'>₹ {total}</span>
//                             </span>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//         </div>
//     )
// }

// export default PrintBill

// import React, { useState, useRef, useEffect, useContext } from 'react'
// import ReactToPrint from "react-to-print";
// import print from "./images/icons/icons8-print-100.png"
// import ss from './images/login/ss_Logo.png'
// import close from './images/Inventory/close (1).png'
// import { DBContext } from './DBContext'
// import { ToastContainer, toast } from 'react-toastify';
// import { useLocation, useNavigate } from 'react-router-dom'
// // import {ipcRenderer} from 'electron'
// import io from 'socket.io-client';
// import PrintableContent from './PrintableContent';

// function PrintBill({ onClose, tableNo, area_id, table, billNo,
//     previousSelectedItems, toIncludeAddonsToPrint, total, orderToKot }) {

//     const api_base_url = process.env.REACT_APP_API_BASE_URL

//     const { logginedDB, customerCode, userType, companyDetails, handleGetCompanyDetails } = useContext(DBContext);
//     const isElectron = navigator.userAgent.toLowerCase().includes('electron');
//     const navigate = useNavigate(null)

//     async function convertImageToBase64(url) {
//         const response = await fetch(url);
//         const blob = await response.blob();
//         return new Promise((resolve) => {
//             const reader = new FileReader();
//             reader.onloadend = () => resolve(reader.result.split(',')[1]);
//             reader.readAsDataURL(blob);
//         });
//     }
//     const logoSrc = `data:image/png;base64,${convertImageToBase64(ss)}`;
//     // // console.log(logoSrc);

//     function getCurrentDate() {
//         const today = new Date();
//         const day = String(today.getDate()).padStart(2, '0');
//         const month = String(today.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
//         const year = today.getFullYear();
//         return `${day}/${month}/${year}`;
//     }

//     function getCurrentTime() {
//         const today = new Date();
//         const hours = String(today.getHours()).padStart(2, '0');
//         const minutes = String(today.getMinutes()).padStart(2, '0');
//         return `${hours}:${minutes}`;
//     }

//     useEffect(() => {
//         // Connect to the WebSocket server
//         const socket = io(api_base_url, {
//             transports: ['websocket'], // Force WebSocket to avoid fallback issues
//         });

//         // Avoid adding multiple listeners
//         socket.on('updateCompany', handleGetCompanyDetails);

//         return () => {
//             socket.off('updateCompany', handleGetCompanyDetails);
//             socket.disconnect();
//         };
//     }, []);

//     const printRef = useRef(null);

//     // const handlePrintBill = async () => {
//     //     try {
//     //         const printers = await window.electron.getPrinters();
//     //         // console.log('Available printers:', printers);
//     //         const printerName = printers.find(p =>
//     //             p.name.includes('POS-58') || p.name.includes('58mm') || p.isDefault
//     //         )?.name;

//     //         if (!printerName) {
//     //             throw new Error('No suitable printer found');
//     //         }

//     //         // console.log('Using printer:', printerName);

//     //         const printStyles = `
//     //         <style>
//     //             @media print {
//     //                 .printButton {
//     //                     display: none !important;
//     //                 }
//     //                 .printCustomClass {
//     //                     width: 58mm !important;
//     //                     font-size: 15px !important;
//     //                     margin: 0 !important;
//     //                     font-family: Arial, sans-serif !important;
//     //                     color: #000 !important;
//     //                 }
//     //                 .printCustomClassContainer {
//     //                     font-size: 1em !important;
//     //                     font-weight: 500 !important;
//     //                     padding: 10px !important;
//     //                     font-family: Arial, sans-serif !important;
//     //                 }
//     //                 .printCustomClassContainerInfo {
//     //                     font-size: 1em !important;
//     //                     font-family: Arial, sans-serif !important;
//     //                 }
//     //                 .printCustomClassContainerTable {
//     //                     font-size: 1em !important;
//     //                     font-family: Arial, sans-serif !important;
//     //                     border-bottom: 1px dashed #000 !important;
//     //                 }
//     //                 .printCustomClassContainerBorderY {
//     //                     border-bottom: 1px dashed #000 !important;
//     //                     border-top: 1px dashed #000 !important;
//     //                 }
//     //                 .paddingYForItems {
//     //                     padding-top: 0.25rem !important;
//     //                     padding-bottom: 0.25rem !important;
//     //                 }
//     //                 .gapY {
//     //                     gap: 0.25rem !important;
//     //                 }
//     //                 .fontSizeClass {
//     //                     font-family: Arial, sans-serif !important;
//     //                 }
//     //                 .highFontWeight {
//     //                     font-weight: 500 !important;
//     //                 }
//     //                 .headWeight {
//     //                     font-weight: 600 !important;
//     //                 }
//     //                 .printCustomClassContainerBorderTop {
//     //                     border-top: 1px dashed #000 !important;
//     //                 }
//     //             }
//     //         </style>
//     //     `;

//     //         const logoSrc = companyDetails.img;

//     //         const htmlContent = `
//     //         <html>
//     //             <head>
//     //                 ${printStyles}
//     //             </head>
//     //             <body>
//     //                 <div style="width: 58mm; font-family: Arial, sans-serif; font-size: 10pt; border-bottom: 1px dashed #000; border-top: 1px dashed #000;">
//     //                     ${printRef.current.innerHTML}
//     //                     <div style="text-align: center; margin-top: 3mm; margin-bottom: 2mm; font-size: 10pt;">Thank You Visit Again</div>
//     //                 </div>
//     //             </body>
//     //         </html>
//     //     `;
//     //         // console.log(printStyles,"\n*********\n",printRef)
//     //         const printResult = await window.electron.printContent({
//     //             html: htmlContent,
//     //             printerName,
//     //             widthMM: 58,
//     //             heightMM: 0 // Let the printer adjust height to content
//     //         });

//     //         if (!printResult.success) {
//     //             throw new Error(printResult.error || 'Direct print failed');
//     //         }

//     //         const response = await fetch(`${api_base_url}/printBill/${logginedDB}/${tableNo}/${area_id}/${table}/${billNo}`, {
//     //             method: 'POST'
//     //         });

//     //         if (response.ok) {
//     //             const data = await response.json();
//     //             toast.success("Printed successfully!");
//     //             if (data.runningKotIsThere) {
//     //                 onClose(false);
//     //             } else {
//     //                 navigate('/TableView');
//     //             }
//     //         }
//     //     } catch (error) {
//     //         console.error("Print Error:", error);
//     //         toast.error(`Print failed: ${error.message}`);
//     //     }
//     // };

//     const handlePrintBill = async () => {
//         try {
//             const printers = await window.electron.getPrinters();
//             const printerName = printers.find(p =>
//                 p.name.includes('POS-58') || p.name.includes('58mm') || p.isDefault
//             )?.name;

//             if (!printerName) throw new Error('No suitable printer found');

//             // Create HTML content for printing
//             const htmlContent = `
//                 <html>
//                     <head>
//                         <style>
//                         @page { size: 58mm auto; margin: 0; }
//                         body {
//                             width: 58mm;
//                             margin: 0;
//                             padding: 1mm;
//                             font-family: Arial, sans-serif;
//                             font-size: 10pt;
//                             -webkit-print-color-adjust: exact;
//                         }
//                         </style>
//                     </head>
//                     <body>
//                         ${printRef.current.innerHTML}
//                     </body>
//                 </html>
//             `;

//             const printResult = await window.electron.printContent({
//                 html: htmlContent,
//                 printerName,
//                 widthMM: 58,
//                 heightMM: 0 // Let it auto-calculate height
//             });

//             if (!printResult.success) throw new Error(printResult.error || 'Print failed');

//             const response = await fetch(`${api_base_url}/printBill/${logginedDB}/${tableNo}/${area_id}/${table}/${billNo}`, {
//                 method: 'POST'
//             });

//             if (response.ok) {
//                 const data = await response.json();
//                 toast.success("Printed successfully!");
//                 if (data.runningKotIsThere) {
//                     onClose(false);
//                 } else {
//                     navigate('/TableView');
//                 }
//             }
//         } catch (error) {
//             console.error("Print Error:", error);
//             toast.error(`Print failed: ${error.message}`);
//         }
//     };

//     const handleAfterPrint = () => {
//         //("e");
//     }
//     return (
//         <div className='relative w-[30rem] h-full flex items-end bg-[#fff] font-nunito'>
//             {/* Print Buttons (will be hidden when printing) */}
//             <div className='absolute top-0 right-0 transform translate-x-full pl-2 flex flex-col gap-2 no-print'>
//                 <button className='p-2 cursor-pointer flex justify-center items-center bg-[#fff]'
//                     onClick={() => onClose(false)}>
//                     <img className='w-[1.5rem]' src={close} alt="Close" />
//                 </button>
//                 <div className='bg-[#fff] flex justify-center items-center'>
//                     <button className="p-2 cursor-pointer hover:bg-[#cddcfc]" onClick={handlePrintBill}>
//                         <img className='w-[2rem]' src={print} alt="Print" />
//                     </button>
//                 </div>
//             </div>

//             {/* Printable Content */}
//             <div ref={printRef} className='no-print-content'>
//                 <PrintableContent
//                     companyDetails={companyDetails}
//                     tableNo={tableNo}
//                     getCurrentTime={getCurrentTime}
//                     getCurrentDate={getCurrentDate}
//                     previousSelectedItems={previousSelectedItems}
//                     toIncludeAddonsToPrint={toIncludeAddonsToPrint}
//                     total={total}
//                 />
//             </div>
//         </div>
//     );
// }

// export default PrintBill;
// //     return (
// //         <div className='relative w-[30rem] printCustomClass h-full flex items-end bg-[#fff] font-nunito' ref={printRef}>
// //             <style>
// //                 {`
// //                     @media print {
// //                         .printButton {
// //                             display: none !important;
// //                         }
// //                         .printCustomClassContainer {
// //                             padding: 5mm !important;
// //                             gap: 1mm !important;
// //                         }
// //                         .paddingYForItems {
// //                             padding-top: 1mm !important;
// //                             padding-bottom: 1mm !important;
// //                         }
// //                         .gapY {
// //                             gap: 1mm !important;
// //                         }
// //                         .printCustomClassContainerBorderTop {
// //                             margin: 1mm 0 !important;
// //                         }
// //                         .printCustomClassContainerBorderY {
// //                             padding: 1mm 0 !important;
// //                         }
// //                         .printCustomClassContainerTable {
// //                             margin-bottom: 1mm !important;
// //                         }
// //                     }
// //                 `}
// //             </style>
// //             <div className='absolute top-0 right-0 transform translate-x-full pl-2 flex flex-col gap-2 printButton'>
// //                 <button className='p-2 cursor-pointer flex justify-center items-center bg-[#fff]' onClick={() => {
// //                     onClose(false)
// //                     if (orderToKot) {
// //                         toast.success("Kot proccessed!", {
// //                             className: 'custom-toast',
// //                             bodyClassName: 'custom-toast-container',
// //                             closeButtonClassName: 'custom-toast-close-button',
// //                             onClose: () => { }
// //                         });
// //                         navigate('/TableView')
// //                     }
// //                 }}>
// //                     <img className='w-[1.5rem]' src={close} alt="" />
// //                 </button>
// //                 <div className='bg-[#fff] flex justify-center items-center'>
// //                     {isElectron ? (
// //                         <>
// //                             <button
// //                                 className="p-2 cursor-pointer hover:bg-[#cddcfc]"
// //                                 onClick={handlePrintBill}
// //                             >
// //                                 <img className='w-[2rem]' src={print} alt="" />
// //                             </button>
// //                         </>
// //                     ) : (
// //                         <>
// //                             <ReactToPrint
// //                                 trigger={() => (
// //                                     <button
// //                                         className="p-2 cursor-pointer hover:bg-[#cddcfc]"
// //                                     // onClick={downloadPDF}
// //                                     >
// //                                         <img className='w-[2rem]' src={print} alt="" />
// //                                     </button>
// //                                 )}
// //                                 content={() => printRef.current}
// //                                 onAfterPrint={handlePrintBill}
// //                                 onPrintError={() => {
// //                                     alert("Print error! Please try again.");
// //                                 }}
// //                             />
// //                         </>
// //                     )}
// //                 </div>

// //             </div>
// //             <div className='printCustomClassContainer w-full h-full flex flex-col p-10 gap-3 overflow-x-hidden overflow-y-auto customScroll'>
// //                 <div className='w-full h-max flex justify-center items-center'>
// //                     <img className='w-[5rem] h-[5rem]' src={companyDetails.img} alt="" />
// //                 </div>
// //                 <div className='w-full h-max flex flex-col justify-center items-center font-[600]'>
// //                     <span className='fontSizeClass headWeight'>SHERDINE</span>
// //                     <span className='fontSizeClass headWeight'>PERINTHALMANNA</span>
// //                     <span className='fontSizeClass headWeight'>GST No M43010G195260</span>
// //                 </div>
// //                 <div className='w-full h-max flex gap-1 text-center justify-center items-center'>
// //                     <div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
// //                     <span className='fontSizeClass highFontWeight'>INVOICE</span>
// //                     <div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
// //                 </div>
// //                 <div className='printCustomClassContainerInfo w-full h-max flex text-[.9rem]'>
// //                     <div className='w-full flex flex-col text-left'>
// //                         <span className='fontSizeClass'>Name : <span className='highFontWeight'>Gopu</span></span>
// //                         <span className='fontSizeClass'>Table : <span className='highFontWeight'>#{tableNo}</span></span>
// //                         <span className='fontSizeClass'>Cashier : <span className='highFontWeight'>biller</span></span>
// //                     </div>
// //                     <div className='w-max text-nowrap flex flex-col text-left'>
// //                         <span className='fontSizeClass w-full flex gap-1'>
// //                             <span className='w-full'>Invoice No : </span>
// //                             <span className='w-max highFontWeight'>369</span>
// //                         </span>
// //                         <span className='fontSizeClass w-full flex gap-1'>
// //                             <span className='w-full'>Time : </span>
// //                             <span className='w-max highFontWeight'>{getCurrentTime()}</span>
// //                         </span>
// //                         <span className='fontSizeClass w-full flex gap-1'>
// //                             <span className='w-full'>Date : </span>
// //                             <span className='w-max highFontWeight'>{getCurrentDate()}</span>
// //                         </span>
// //                     </div>
// //                 </div>
// //                 <div className='w-full flex flex-col'>
// //                     <div className='w-full printCustomClassContainerBorderY flex border-y-2 border-dashed border-[#b6b6b6] font-[600]'>
// //                         <div className='w-6/12 py-2 fontSizeClass '>Item</div>
// //                         <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Price</div>
// //                         <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Qty</div>
// //                         <div className='w-2/12 py-2 flex justify-end items-center fontSizeClass '>Total</div>
// //                     </div>
// //                     <div className='w-full flex flex-col pb-1 border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
// //                         {previousSelectedItems.map((item, index) => {
// //                             const hasVariant = item.variantName || null
// //                             return (
// //                                 <div key={index} className='w-full flex'>
// //                                     <div className=' text-wrap w-6/12 py-2 fontSizeClass paddingYForItems'>{hasVariant ? `${item.productName} ${item.variantName}` : item.productName}</div>
// //                                     <div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>₹ {item.rate}</div>
// //                                     <div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>{item.quantity}</div>
// //                                     <div className='w-2/12 py-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>₹ {item.quantity * item.rate}</div>
// //                                 </div>
// //                             )
// //                         })}
// //                         {toIncludeAddonsToPrint.map((addon, index) => {
// //                             return (
// //                                 <div key={index} className='w-full flex text-nowrap'>
// //                                     <div className='w-6/12 py-2 fontSizeClass paddingYForItems'>{addon.addonName}</div>
// //                                     <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>₹ {addon.rate}</div>
// //                                     <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>{addon.quantity}</div>
// //                                     <div className='w-2/12 py-2 flex justify-end items-center fontSizeClass paddingYForItems'>₹ {addon.quantity * addon.rate}</div>
// //                                 </div>
// //                             )
// //                         })}
// //                     </div>
// //                 </div>
// //                 <div className='w-full h-max flex flex-col gap-3 text-nowrap border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
// //                     <div className='w-full flex flex-col gap-2 gapY'>
// //                         <div className='w-full flex'>
// //                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>Sub-Total :</span>
// //                             <span className='w-4/12 flex justify-end items-center'>
// //                                 <span className='w-full text-center'></span>
// //                                 <span className='w-max pl-2 text-left fontSizeClass '>₹ {total}</span>
// //                             </span>
// //                         </div>
// //                         <div className='w-full flex'>
// //                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>CGST :</span>
// //                             <span className='w-4/12 flex justify-end items-center'>
// //                                 <span className='w-1/2 text-center fontSizeClass '>0%</span>
// //                                 <span className='w-1/2 pl-2 text-right fontSizeClass '>₹ 0</span>
// //                             </span>
// //                         </div>
// //                         <div className='w-full flex'>
// //                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>SGST :</span>
// //                             <span className='w-4/12 flex justify-end items-center'>
// //                                 <span className='w-1/2 text-center fontSizeClass '>0%</span>
// //                                 <span className='w-1/2 pl-2 text-right fontSizeClass '>₹ 0</span>
// //                             </span>
// //                         </div>
// //                     </div>
// //                     <div className='w-full flex text-nowrap'>
// //                         <div className='w-1/2'></div>
// //                         <div className='w-1/2 printCustomClassContainerBorderTop flex py-3 border-t-2 border-dashed border-[#b6b6b6]'>
// //                             <span className='w-1/3 flex justify-end items-center font-[600] text-[1.05rem] fontSizeClass '>Total :</span>
// //                             <span className='w-2/3 flex justify-end items-center'>
// //                                 <span className='w-full text-center'></span>
// //                                 <span className='w-max pl-2 text-left fontSizeClass'>₹ {total}</span>
// //                             </span>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     )
// // }

// // export default PrintBill

// import React, { useState, useRef, useEffect, useContext } from "react";
// import ReactToPrint from "react-to-print";
// import print from "./images/icons/icons8-print-100.png";
// import ss from "./images/login/ss_Logo.png";
// import close from "./images/Inventory/close (1).png";
// import { DBContext } from "./DBContext";
// import { ToastContainer, toast } from "react-toastify";
// import { useLocation, useNavigate } from "react-router-dom";
// // import {ipcRenderer} from 'electron'
// import io from "socket.io-client";
// import PrintableContent from "./PrintableContent";

// function PrintBill({
// 	onClose,
// 	tableNo,
// 	area_id,
// 	table,
// 	billNo,
// 	previousSelectedItems,
// 	toIncludeAddonsToPrint,
// 	total,
// 	orderToKot,
// }) {
// 	const api_base_url = process.env.REACT_APP_API_BASE_URL;

// 	const {
// 		logginedDB,
// 		customerCode,
// 		userType,
// 		companyDetails,
// 		handleGetCompanyDetails,
// 		PrintPreview,
// 	} = useContext(DBContext);
// 	const isElectron = navigator.userAgent.toLowerCase().includes("electron");
// 	const navigate = useNavigate(null);
// 	// console.log("PrintPreview", companyDetails.PrintPreview);

// 	async function convertImageToBase64(url) {
// 		const response = await fetch(url);
// 		const blob = await response.blob();
// 		return new Promise((resolve) => {
// 			const reader = new FileReader();
// 			reader.onloadend = () => resolve(reader.result.split(",")[1]);
// 			reader.readAsDataURL(blob);
// 		});
// 	}
// 	const logoSrc = `data:image/png;base64,${convertImageToBase64(ss)}`;
// 	// // console.log(logoSrc);

// 	function getCurrentDate() {
// 		const today = new Date();
// 		const day = String(today.getDate()).padStart(2, "0");
// 		const month = String(today.getMonth() + 1).padStart(2, "0"); // getMonth() is zero-based
// 		const year = today.getFullYear();
// 		return `${day}/${month}/${year}`;
// 	}

// 	function getCurrentTime() {
// 		const today = new Date();
// 		const hours = String(today.getHours()).padStart(2, "0");
// 		const minutes = String(today.getMinutes()).padStart(2, "0");
// 		return `${hours}:${minutes}`;
// 	}

// 	// useEffect(() => {
// 	//     // Connect to the WebSocket server
// 	//     const socket = io(api_base_url, {
// 	//         transports: ['websocket'], // Force WebSocket to avoid fallback issues
// 	//     });

// 	//     // Avoid adding multiple listeners
// 	//     socket.on('updateCompany', handleGetCompanyDetails);

// 	//     return () => {
// 	//         socket.off('updateCompany', handleGetCompanyDetails);
// 	//         socket.disconnect();
// 	//     };
// 	// }, []);

// 	const socketRef = useRef(null);

// 	// useEffect(() => {
// 	//   if (!logginedDB) return; // if not logged in, skip

// 	//   // connect socket
// 	//   socketRef.current = io(api_base_url, {
// 	//     transports: ["websocket"], // faster than polling
// 	//   });

// 	//   // make sure old listeners are removed before adding new ones
// 	//   socketRef.current
// 	//     .off("updateCompany")
// 	//     .on("updateCompany",   handleGetCompanyDetails());

// 	//   // cleanup on unmount
// 	//   return () => {
// 	//     socketRef.current.disconnect();
// 	//   };
// 	// }, [api_base_url, logginedDB]);

// 	useEffect(() => {
// 		if (!logginedDB) return;

// 		handleGetCompanyDetails();

// 		socketRef.current = io(api_base_url, {
// 			transports: ["websocket"],
// 		});

// 		// Event listeners
// 		const geteHandleCompanyDetails = () => handleGetCompanyDetails();

// 		socketRef.current.on("connect", () => {
// 			// console.log("Connected to server");
// 		});

// 		socketRef.current.on("disconnect", () => {
// 			// console.log("Disconnected from server");
// 		});

// 		socketRef.current.on("connect_error", (error) => {
// 			console.error("Connection error:", error);
// 		});

// 		socketRef.current.on("updateCompany", geteHandleCompanyDetails);

// 		return () => {
// 			if (socketRef.current) {
// 				socketRef.current.off("updateCompany", geteHandleCompanyDetails);
// 				socketRef.current.disconnect();
// 			}
// 		};
// 	}, [api_base_url, logginedDB]);

// 	const printRef = useRef(null);

// 	// const getPrintableContent = () => {
// 	//     // Create a clone of your existing UI structure but without buttons
// 	//     return `
// 	//         <div class="printCustomClassContainer" style="width:58mm; font-family:Arial; padding:10px;">
// 	//             <div style="text-align:center; margin-bottom:10px;">
// 	//                 <img style="width:5rem; height:5rem;" src="${companyDetails.img}" alt="" />
// 	//             </div>
// 	//             <div style="text-align:center; font-weight:600; margin-bottom:5px;">
// 	//                 <div class="fontSizeClass headWeight">SHERDINE</div>
// 	//                 <div class="fontSizeClass headWeight">PERINTHALMANNA</div>
// 	//                 <div class="fontSizeClass headWeight">GST No M43010G195260</div>
// 	//             </div>

// 	//             <div style="display:flex; justify-content:center; align-items:center; margin:5px 0;">
// 	//                 <div style="flex-grow:1; height:1px; border-top:1px dashed #000;"></div>
// 	//                 <span class="fontSizeClass highFontWeight" style="margin:0 5px;">INVOICE</span>
// 	//                 <div style="flex-grow:1; height:1px; border-top:1px dashed #000;"></div>
// 	//             </div>

// 	//             ${document.querySelector('.printCustomClassContainerInfo').outerHTML}
// 	//             ${document.querySelector('.printCustomClassContainer > div:nth-child(5)').outerHTML}
// 	//             ${document.querySelector('.printCustomClassContainer > div:nth-child(6)').outerHTML}

// 	//             <div style="text-align:center; margin-top:10px; font-size:10pt;">
// 	//                 Thank You Visit Again
// 	//             </div>
// 	//         </div>
// 	//     `;
// 	// };

// 	const handlePrintBill = async () => {
// 		try {
// 			const printers = await window.electron.getPrinters();

// 			const printerName = printers.find(
// 				(p) =>
// 					p.name.includes("POS-58") || p.name.includes("58mm") || p.isDefault
// 			)?.name;

// 			if (!printerName) throw new Error("No suitable printer found");

// 			// console.log("Using printer:", printerName);

// 			const printStyles = `
//             <style>
//                 @media print {
//                     .printButton {
//                         display: none !important;
//                     }
//                     .printCustomClass {
//                         width: 58mm !important;
//                         font-size: 15px !important;
//                         margin: 0 !important;
//                         font-family: Arial, sans-serif !important;
//                         color: #000 !important;
//                     }
//                     .printCustomClassContainer {
//                         font-size: 1em !important;
//                         font-weight: 500 !important;
//                         padding: 10px !important;
//                         font-family: Arial, sans-serif !important;
//                     }
//                     .printCustomClassContainerInfo {
//                         font-size: 1em !important;
//                         font-family: Arial, sans-serif !important;
//                     }
//                     .printCustomClassContainerTable {
//                         font-size: 1em !important;
//                         font-family: Arial, sans-serif !important;
//                         border-bottom: 1px dashed #000 !important;
//                     }
//                     .printCustomClassContainerBorderY {
//                         border-bottom: 1px dashed #000 !important;
//                         border-top: 1px dashed #000 !important;
//                     }
//                     .paddingYForItems {
//                         padding-top: 0.25rem !important;
//                         padding-bottom: 0.25rem !important;
//                     }
//                     .gapY {
//                         gap: 0.25rem !important;
//                     }
//                     .fontSizeClass {
//                         font-family: Arial, sans-serif !important;
//                     }
//                     .highFontWeight {
//                         font-weight: 500 !important;
//                     }
//                     .headWeight {
//                         font-weight: 600 !important;
//                     }
//                     .printCustomClassContainerBorderTop {
//                         border-top: 1px dashed #000 !important;
//                     }
//                 }
//             </style>
//         `;

// 			const logoSrc = companyDetails.img;

// 			const htmlContent = `
//             <html>
//                 <head>
//                     ${printStyles}
//                 </head>
//                 <body>
//                     <div style="width: 58mm; font-family: Arial, sans-serif; font-size: 10pt; border-bottom: 1px dashed #000; border-top: 1px dashed #000;">
//                         ${printRef.current.innerHTML}
//                         <div style="text-align: center; margin-top: 3mm; margin-bottom: 2mm; font-size: 10pt;">Thank You Visit Again</div>
//                     </div>
//                 </body>
//             </html>
//         `;
// 			// console.log(printStyles, "\n*********\n", printRef);
// 			const printResult = await window.electron.printContent({
// 				html: htmlContent,
// 				printerName,
// 				widthMM: 58,
// 				heightMM: 0, // Let the printer adjust height to content
// 			});

// 			if (!printResult.success) {
// 				throw new Error(printResult.error || "Direct print failed");
// 			}

// 			const response = await fetch(
// 				`${api_base_url}/printBill/${logginedDB}/${tableNo}/${area_id}/${table}/${billNo}`,
// 				{
// 					method: "POST",
// 				}
// 			);

// 			if (response.ok) {
// 				const data = await response.json();
// 				toast.success("Printed successfully!");
// 				if (data.runningKotIsThere) {
// 					onClose(false);
// 				} else {
// 					navigate("/TableView");
// 				}
// 			}
// 		} catch (error) {
// 			console.error("Print Error:", error);
// 			toast.error(`Print failed: ${error.message}`);
// 		}
// 	};

// 	const handleAfterPrint = () => {
// 		//("e");
// 	};
// 	return (
// 		<div
// 			className="relative w-[30rem] printCustomClass h-full flex items-end bg-[#fff] font-nunito"
// 			ref={printRef}
// 		>
// 			<style>
// 				{`
//                     @media print {
//                         .printButton {
//                             display: none !important;
//                         }
//                         .printCustomClassContainer {
//                             padding: 5mm !important;
//                             gap: 1mm !important;
//                         }
//                         .paddingYForItems {
//                             padding-top: 1mm !important;
//                             padding-bottom: 1mm !important;
//                         }
//                         .gapY {
//                             gap: 1mm !important;
//                         }
//                         .printCustomClassContainerBorderTop {
//                             margin: 1mm 0 !important;
//                         }
//                         .printCustomClassContainerBorderY {
//                             padding: 1mm 0 !important;
//                         }
//                         .printCustomClassContainerTable {
//                             margin-bottom: 1mm !important;
//                         }
//                     }
//                 `}
// 			</style>
// 			<div className="absolute top-0 right-0 transform translate-x-full pl-2 flex flex-col gap-2 printButton">
// 				<button
// 					className="p-2 cursor-pointer flex justify-center items-center bg-[#fff]"
// 					onClick={() => {
// 						onClose(false);
// 						if (orderToKot) {
// 							toast.success("Kot proccessed!", {
// 								className: "custom-toast",
// 								bodyClassName: "custom-toast-container",
// 								closeButtonClassName: "custom-toast-close-button",
// 								onClose: () => { },
// 							});
// 							navigate("/TableView");
// 						}
// 					}}
// 				>
// 					<img className="w-[1.5rem]" src={close} alt="" />
// 				</button>
// 				<div className="bg-[#fff] flex justify-center items-center">
// 					{isElectron ? (
// 						<button
// 							className="p-2 cursor-pointer hover:bg-[#cddcfc]"
// 							onClick={handlePrintBill}
// 						>
// 							<img className="w-[2rem]" src={print} alt="" />
// 						</button>
// 					) : (
// 						<ReactToPrint
// 							trigger={() => (
// 								<button
// 									className="p-2 cursor-pointer hover:bg-[#cddcfc]"
// 								// onClick={downloadPDF}
// 								>
// 									<img className="w-[2rem]" src={print} alt="" />
// 								</button>
// 							)}
// 							content={() => printRef.current}
// 							onAfterPrint={handlePrintBill}
// 							onPrintError={() => {
// 								alert("Print error! Please try again.");
// 							}}
// 						/>
// 					)}
// 				</div>
// 			</div>
// 			<div className="printCustomClassContainer w-full h-full flex flex-col p-10 gap-3 overflow-x-hidden overflow-y-auto customScroll">
// 				<div className="w-full h-max flex justify-center items-center">
// 					<img className="w-[5rem] h-[5rem]" src={companyDetails.img} alt="" />
// 				</div>
// 				<div className="w-full h-max flex flex-col justify-center items-center font-[600]">
// 					<span className="fontSizeClass headWeight">SHERDINE</span>
// 					<span className="fontSizeClass headWeight">PERINTHALMANNA</span>
// 					<span className="fontSizeClass headWeight">GST No M43010G195260</span>
// 				</div>
// 				<div className="w-full h-max flex gap-1 text-center justify-center items-center">
// 					<div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
// 					<span className="fontSizeClass highFontWeight">INVOICE</span>
// 					<div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
// 				</div>
// 				<div className="printCustomClassContainerInfo w-full h-max flex text-[.9rem]">
// 					<div className="w-full flex flex-col text-left">
// 						<span className="fontSizeClass">
// 							Name : <span className="highFontWeight">Gopu</span>
// 						</span>
// 						<span className="fontSizeClass">
// 							Table : <span className="highFontWeight">#{tableNo}</span>
// 						</span>
// 						<span className="fontSizeClass">
// 							Cashier : <span className="highFontWeight">biller</span>
// 						</span>
// 					</div>
// 					<div className="w-max text-nowrap flex flex-col text-left">
// 						<span className="fontSizeClass w-full flex gap-1">
// 							<span className="w-full">Invoice No : </span>
// 							<span className="w-max highFontWeight">369</span>
// 						</span>
// 						<span className="fontSizeClass w-full flex gap-1">
// 							<span className="w-full">Time : </span>
// 							<span className="w-max highFontWeight">{getCurrentTime()}</span>
// 						</span>
// 						<span className="fontSizeClass w-full flex gap-1">
// 							<span className="w-full">Date : </span>
// 							<span className="w-max highFontWeight">{getCurrentDate()}</span>
// 						</span>
// 					</div>
// 				</div>
// 				<div className="w-full flex flex-col">
// 					<div className="w-full printCustomClassContainerBorderY flex border-y-2 border-dashed border-[#b6b6b6] font-[600]">
// 						<div className="w-6/12 py-2 fontSizeClass ">Item</div>
// 						<div className="w-2/12 p-2 flex justify-end items-center fontSizeClass ">
// 							Price
// 						</div>
// 						<div className="w-2/12 p-2 flex justify-end items-center fontSizeClass ">
// 							Qty
// 						</div>
// 						<div className="w-2/12 py-2 flex justify-end items-center fontSizeClass ">
// 							Total
// 						</div>
// 					</div>
// 					<div className="w-full flex flex-col pb-1 border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable">
// 						{previousSelectedItems.map((item, index) => {
// 							const hasVariant = item.variantName || null;
// 							return (
// 								<div key={index} className="w-full flex">
// 									<div className=" text-wrap w-6/12 py-2 fontSizeClass paddingYForItems">
// 										{hasVariant
// 											? `${item.productName} ${item.variantName}`
// 											: item.productName}
// 									</div>
// 									<div className="w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems">
// 										₹ {item.rate}
// 									</div>
// 									<div className="w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems">
// 										{item.quantity}
// 									</div>
// 									<div className="w-2/12 py-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems">
// 										₹ {item.quantity * item.rate}
// 									</div>
// 								</div>
// 							);
// 						})}
// 						{toIncludeAddonsToPrint.map((addon, index) => {
// 							return (
// 								<div key={index} className="w-full flex text-nowrap">
// 									<div className="w-6/12 py-2 fontSizeClass paddingYForItems">
// 										{addon.addonName}
// 									</div>
// 									<div className="w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems">
// 										₹ {addon.rate}
// 									</div>
// 									<div className="w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems">
// 										{addon.quantity}
// 									</div>
// 									<div className="w-2/12 py-2 flex justify-end items-center fontSizeClass paddingYForItems">
// 										₹ {addon.quantity * addon.rate}
// 									</div>
// 								</div>
// 							);
// 						})}
// 					</div>
// 				</div>
// 				<div className="w-full h-max flex flex-col gap-3 text-nowrap border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable">
// 					<div className="w-full flex flex-col gap-2 gapY">
// 						<div className="w-full flex">
// 							<span className="w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight">
// 								Sub-Total :
// 							</span>
// 							<span className="w-4/12 flex justify-end items-center">
// 								<span className="w-full text-center"></span>
// 								<span className="w-max pl-2 text-left fontSizeClass ">
// 									₹ {total}
// 								</span>
// 							</span>
// 						</div>
// 						<div className="w-full flex">
// 							<span className="w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight">
// 								CGST :
// 							</span>
// 							<span className="w-4/12 flex justify-end items-center">
// 								<span className="w-1/2 text-center fontSizeClass ">0%</span>
// 								<span className="w-1/2 pl-2 text-right fontSizeClass ">
// 									₹ 0
// 								</span>
// 							</span>
// 						</div>
// 						<div className="w-full flex">
// 							<span className="w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight">
// 								SGST :
// 							</span>
// 							<span className="w-4/12 flex justify-end items-center">
// 								<span className="w-1/2 text-center fontSizeClass ">0%</span>
// 								<span className="w-1/2 pl-2 text-right fontSizeClass ">
// 									₹ 0
// 								</span>
// 							</span>
// 						</div>
// 					</div>
// 					<div className="w-full flex text-nowrap">
// 						<div className="w-1/2"></div>
// 						<div className="w-1/2 printCustomClassContainerBorderTop flex py-3 border-t-2 border-dashed border-[#b6b6b6]">
// 							<span className="w-1/3 flex justify-end items-center font-[600] text-[1.05rem] fontSizeClass ">
// 								Total :
// 							</span>
// 							<span className="w-2/3 flex justify-end items-center">
// 								<span className="w-full text-center"></span>
// 								<span className="w-max pl-2 text-left fontSizeClass">
// 									₹ {total}
// 								</span>
// 							</span>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 		</div>
// 	);
// }

// export default PrintBill;

//09-12-25 latest
// import React, { useState, useRef, useEffect, useContext } from 'react';

// import BillDesigner from './InvoiceDesigner/BillDesigner';
// import ReactToPrint from "react-to-print";
// // import React, { useState, useRef, useEffect, useContext } from 'react'
// // import ReactToPrint from "react-to-print";
// import print from "./images/icons/icons8-print-100.png"
// import ss from './images/login/ss_Logo.png'
// import close from './images/Inventory/close (1).png'
// import { DBContext } from './DBContext'
// import { ToastContainer, toast } from 'react-toastify';
// import { useLocation, useNavigate } from 'react-router-dom'
// // import {ipcRenderer} from 'electron'
// import io from 'socket.io-client';

// function PrintBill({ onClose, tableNo, area_id, table, billNo, previousSelectedItems, toIncludeAddonsToPrint, total, orderToKot }) {

//     const api_base_url = process.env.REACT_APP_API_BASE_URL

//     const { logginedDB, customerCode, userType, companyDetails, handleGetCompanyDetails } = useContext(DBContext);

//     const navigate = useNavigate(null)

//     function getCurrentDate() {
//         const today = new Date();
//         const day = String(today.getDate()).padStart(2, '0');
//         const month = String(today.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
//         const year = today.getFullYear();
//         return `${day}/${month}/${year}`;
//     }

//     function getCurrentTime() {
//         const today = new Date();
//         const hours = String(today.getHours()).padStart(2, '0');
//         const minutes = String(today.getMinutes()).padStart(2, '0');
//         return `${hours}:${minutes}`;
//     }

//     useEffect(() => {
//         const socket = io(api_base_url, {
//             transports: ['websocket'], // Force WebSocket to avoid fallback issues
//         });

//         socket.on('updateCompany', handleGetCompanyDetails);

//         return () => {
//             socket.off('updateCompany', handleGetCompanyDetails);
//             socket.disconnect();
//         };
//     }, []);

//     const printRef = useRef(null);

//     const handlePrintBill = async () => {

//         try {
//             const response = await fetch(`${api_base_url}/printBill/${logginedDB}/${tableNo}/${area_id}/${table}/${billNo}`, {
//                 method: 'POST'
//             });

//             if (response.ok) {
//                 const data = await response.json()
//                 // //(data);

//                 if (data.runningKotIsThere) {
//                     toast.success("Printed success!", {
//                         className: 'custom-toast',
//                         bodyClassName: 'custom-toast-container',
//                         closeButtonClassName: 'custom-toast-close-button',
//                         onClose: () => { }
//                     });
//                     onClose(false)
//                 } else {
//                     toast.success("Printed success!", {
//                         className: 'custom-toast',
//                         bodyClassName: 'custom-toast-container',
//                         closeButtonClassName: 'custom-toast-close-button',
//                         onClose: () => { }
//                     });
//                     navigate('/TableView')
//                 }
//             } else {
//                 console.error("Error in API call:", response.status);
//             }
//         } catch (error) {
//             console.error("Fetch Error:", error);
//         }

//     }

//     const handleAfterPrint = () => {
//     }
//     return (
//         <div className='relative w-[30rem] printCustomClass h-full flex items-end bg-[#fff] font-nunito' ref={printRef}>
//             <div className='absolute top-0 right-0 transform translate-x-full pl-2 flex flex-col gap-2 printButton'>blaa
//                 <button className='p-2 cursor-pointer flex justify-center items-center bg-[#fff]' onClick={() => {
//                     onClose(false)
//                     if (orderToKot) {
//                         toast.success("Kot proccessed!", {
//                             className: 'custom-toast',
//                             bodyClassName: 'custom-toast-container',
//                             closeButtonClassName: 'custom-toast-close-button',
//                             onClose: () => { }
//                         });
//                         navigate('/TableView')
//                     }
//                 }}>
//                     <img className='w-[1.5rem]' src={close} alt="" />
//                 </button>
//                 <div className='bg-[#fff] flex justify-center items-center'>
//                     <ReactToPrint
//                         trigger={() => (
//                             <button
//                                 className="p-2 cursor-pointer hover:bg-[#cddcfc]"
//                             >
//                                 <img className='w-[2rem]' src={print} alt="" />
//                             </button>
//                         )}
//                         content={() => printRef.current}
//                         onAfterPrint={handlePrintBill}
//                         onPrintError={() => {
//                             alert("Print error! Please try again.");
//                         }}
//                     />
//                 </div>
//             </div>
//             <div className='printCustomClassContainer w-full h-full flex flex-col p-10 gap-3 overflow-x-hidden overflow-y-auto customScroll'>
//                 <div className='w-full h-max flex justify-center items-center'>
//                     <img className='w-[5rem] h-[5rem]' src={companyDetails.img} alt="" />
//                 </div>
//                 <div className='w-full h-max flex flex-col justify-center items-center font-[600]'>
//                     <span className='fontSizeClass headWeight'>SHERDINE</span>
//                     <span className='fontSizeClass headWeight'>PERINTHALMANNA</span>
//                     <span className='fontSizeClass headWeight'>GST No M43010G195260</span>
//                 </div>
//                 <div className='w-full h-max flex gap-1 text-center justify-center items-center'>
//                     <div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
//                     <span className='fontSizeClass highFontWeight'>INVOICE</span>
//                     <div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
//                 </div>
//                 <div className='printCustomClassContainerInfo w-full h-max flex text-[.9rem]'>
//                     <div className='w-full flex flex-col text-left'>
//                         <span className='fontSizeClass'>Name : <span className='highFontWeight'>Gopu</span></span>
//                         <span className='fontSizeClass'>Table : <span className='highFontWeight'>#{tableNo}</span></span>
//                         <span className='fontSizeClass'>Cashier : <span className='highFontWeight'>biller</span></span>
//                     </div>
//                     <div className='w-max text-nowrap flex flex-col text-left'>
//                         <span className='fontSizeClass w-full flex gap-1'>
//                             <span className='w-full'>Invoice No : </span>
//                             <span className='w-max highFontWeight'>369</span>
//                         </span>
//                         <span className='fontSizeClass w-full flex gap-1'>
//                             <span className='w-full'>Time : </span>
//                             <span className='w-max highFontWeight'>{getCurrentTime()}</span>
//                         </span>
//                         <span className='fontSizeClass w-full flex gap-1'>
//                             <span className='w-full'>Date : </span>
//                             <span className='w-max highFontWeight'>{getCurrentDate()}</span>
//                         </span>
//                     </div>
//                 </div>
//                 <div className='w-full flex flex-col'>
//                     <div className='w-full printCustomClassContainerBorderY flex border-y-2 border-dashed border-[#b6b6b6] font-[600]'>
//                         <div className='w-6/12 py-2 fontSizeClass '>Item</div>
//                         <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Price</div>
//                         <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Qty</div>
//                         <div className='w-2/12 py-2 flex justify-end items-center fontSizeClass '>Total</div>
//                     </div>
//                     <div className='w-full flex flex-col pb-1 border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
//                         {previousSelectedItems.map((item, index) => {
//                             const hasVariant = item.variantName || null
//                             return (
//                                 <div key={index} className='w-full flex'>
//                                     <div className=' text-wrap w-6/12 py-2 fontSizeClass paddingYForItems'>{hasVariant ? `${item.productName} ${item.variantName}` : item.productName}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>₹ {item.rate}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>{item.quantity}</div>
//                                     <div className='w-2/12 py-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>₹ {item.quantity * item.rate}</div>
//                                 </div>
//                             )
//                         })}
//                         {toIncludeAddonsToPrint.map((addon, index) => {
//                             return (
//                                 <div key={index} className='w-full flex text-nowrap'>
//                                     <div className='w-6/12 py-2 fontSizeClass paddingYForItems'>{addon.addonName}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>₹ {addon.rate}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>{addon.quantity}</div>
//                                     <div className='w-2/12 py-2 flex justify-end items-center fontSizeClass paddingYForItems'>₹ {addon.quantity * addon.rate}</div>
//                                 </div>
//                             )
//                         })}
//                     </div>
//                 </div>
//                 <div className='w-full h-max flex flex-col gap-3 text-nowrap border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
//                     <div className='w-full flex flex-col gap-2 gapY'>
//                         <div className='w-full flex'>
//                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>Sub-Total :</span>
//                             <span className='w-4/12 flex justify-end items-center'>
//                                 <span className='w-full text-center'></span>
//                                 <span className='w-max pl-2 text-left fontSizeClass '>₹ {total}</span>
//                             </span>
//                         </div>
//                         <div className='w-full flex'>
//                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>CGST :</span>
//                             <span className='w-4/12 flex justify-end items-center'>
//                                 <span className='w-1/2 text-center fontSizeClass '>0%</span>
//                                 <span className='w-1/2 pl-2 text-right fontSizeClass '>₹ 0</span>
//                             </span>
//                         </div>
//                         <div className='w-full flex'>
//                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>SGST :</span>
//                             <span className='w-4/12 flex justify-end items-center'>
//                                 <span className='w-1/2 text-center fontSizeClass '>0%</span>
//                                 <span className='w-1/2 pl-2 text-right fontSizeClass '>₹ 0</span>
//                             </span>
//                         </div>
//                     </div>
//                     <div className='w-full flex text-nowrap'>
//                         <div className='w-1/2'></div>
//                         <div className='w-1/2 printCustomClassContainerBorderTop flex py-3 border-t-2 border-dashed border-[#b6b6b6]'>
//                             <span className='w-1/3 flex justify-end items-center font-[600] text-[1.05rem] fontSizeClass '>Total :</span>
//                             <span className='w-2/3 flex justify-end items-center'>
//                                 <span className='w-full text-center'></span>
//                                 <span className='w-max pl-2 text-left fontSizeClass'>₹ {total}</span>
//                             </span>

//                         </div>
//                     </div>
//                     <div className='w-full h-max flex flex-col justify-center items-center font-[600]'>
//                         Thank You .... Visit Again 
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default PrintBill

// import React, { useState, useRef, useEffect, useContext } from 'react';
// import BillDesigner from './InvoiceDesigner/BillDesigner';
// import ReactToPrint from "react-to-print";
// import print from "./images/icons/icons8-print-100.png"
// import ss from './images/login/ss_Logo.png'
// import close from './images/Inventory/close (1).png'
// import { DBContext } from './DBContext'
// import { ToastContainer, toast } from 'react-toastify';
// import { useLocation, useNavigate } from 'react-router-dom'
// import io from 'socket.io-client';

// function PrintBill({ onClose, tableNo, area_id, table, billNo, previousSelectedItems, toIncludeAddonsToPrint, total, orderToKot }) {

//     const api_base_url = process.env.REACT_APP_API_BASE_URL
//     const { logginedDB, customerCode, userType, companyDetails, handleGetCompanyDetails } = useContext(DBContext);
//     const navigate = useNavigate(null)

//     // State for designer mode and design data
//     const [designMode, setDesignMode] = useState(false);
//     const [billDesign, setBillDesign] = useState(null);
//     const printRef = useRef(null);

//     function getCurrentDate() {
//         const today = new Date();
//         const day = String(today.getDate()).padStart(2, '0');
//         const month = String(today.getMonth() + 1).padStart(2, '0');
//         const year = today.getFullYear();
//         return `${day}/${month}/${year}`;
//     }

//     function getCurrentTime() {
//         const today = new Date();
//         const hours = String(today.getHours()).padStart(2, '0');
//         const minutes = String(today.getMinutes()).padStart(2, '0');
//         return `${hours}:${minutes}`;
//     }

//     // Load saved design from localStorage
//     useEffect(() => {
//         const savedDesign = localStorage.getItem('billDesign');
//         if (savedDesign) {
//             setBillDesign(JSON.parse(savedDesign));
//         }
//     }, []);

//     useEffect(() => {
//         const socket = io(api_base_url, {
//             transports: ['websocket'],
//         });

//         socket.on('updateCompany', handleGetCompanyDetails);

//         return () => {
//             socket.off('updateCompany', handleGetCompanyDetails);
//             socket.disconnect();
//         };
//     }, []);

//     const handlePrintBill = async () => {
//         try {
//             const response = await fetch(`${api_base_url}/printBill/${logginedDB}/${tableNo}/${area_id}/${table}/${billNo}`, {
//                 method: 'POST'
//             });

//             if (response.ok) {
//                 const data = await response.json()
//                 if (data.runningKotIsThere) {
//                     toast.success("Printed success!", {
//                         className: 'custom-toast',
//                         bodyClassName: 'custom-toast-container',
//                         closeButtonClassName: 'custom-toast-close-button',
//                         onClose: () => { }
//                     });
//                     onClose(false)
//                 } else {
//                     toast.success("Printed success!", {
//                         className: 'custom-toast',
//                         bodyClassName: 'custom-toast-container',
//                         closeButtonClassName: 'custom-toast-close-button',
//                         onClose: () => { }
//                     });
//                     navigate('/TableView')
//                 }
//             } else {
//                 console.error("Error in API call:", response.status);
//             }
//         } catch (error) {
//             console.error("Fetch Error:", error);
//         }
//     }

//     const handleSaveDesign = (design) => {
//         setBillDesign(design);
//         localStorage.setItem('billDesign', JSON.stringify(design));
//         setDesignMode(false);
//         toast.success("Design saved successfully!", {
//             className: 'custom-toast',
//             bodyClassName: 'custom-toast-container',
//             closeButtonClassName: 'custom-toast-close-button',
//         });
//     };

//     // Function to render designed bill with dynamic data
//     const renderDesignedBill = () => {
//         if (!billDesign) return renderDefaultBill();

//         return (
//             <div 
//                 className="designed-bill w-full h-full flex flex-col p-10 gap-3 overflow-x-hidden overflow-y-auto customScroll"
//                 style={{
//                     backgroundColor: billDesign.backgroundColor || '#ffffff',
//                     minHeight: billDesign.canvasSize?.height || '600px'
//                 }}
//             >
//                 {billDesign.elements.map(element => (
//                     <DesignedBillElement
//                         key={element.id}
//                         element={element}
//                         dynamicData={{
//                             companyDetails,
//                             tableNo,
//                             getCurrentTime,
//                             getCurrentDate,
//                             previousSelectedItems,
//                             toIncludeAddonsToPrint,
//                             total
//                         }}
//                     />
//                 ))}
//             </div>
//         );
//     };

//     // Component to render individual designed elements with dynamic data
//     const DesignedBillElement = ({ element, dynamicData }) => {
//         const {
//             companyDetails,
//             tableNo,
//             getCurrentTime,
//             getCurrentDate,
//             previousSelectedItems,
//             toIncludeAddonsToPrint,
//             total
//         } = dynamicData;

//         const getDynamicContent = (content) => {
//             // Replace placeholders with actual data
//             return content
//                 .replace('{{companyName}}', companyDetails?.name || 'SHERDINE')
//                 .replace('{{companyLocation}}', companyDetails?.location || 'PERINTHALMANNA')
//                 .replace('{{gstNumber}}', companyDetails?.gst || 'GST No M43010G195260')
//                 .replace('{{tableNo}}', tableNo || '')
//                 .replace('{{currentTime}}', getCurrentTime())
//                 .replace('{{currentDate}}', getCurrentDate())
//                 .replace('{{totalAmount}}', `₹ ${total}`)
//                 .replace('{{subTotal}}', `₹ ${total}`)
//                 .replace('{{invoiceNumber}}', billNo || '369');
//         };

//         const style = {
//             position: element.type !== 'line' ? 'absolute' : 'static',
//             left: `${element.x}px`,
//             top: `${element.y}px`,
//             width: `${element.width}px`,
//             height: `${element.height}px`,
//             ...element.styles
//         };

//         switch (element.type) {
//             case 'header':
//             case 'subheader':
//             case 'text':
//             case 'price':
//                 return (
//                     <div style={style}>
//                         {getDynamicContent(element.content)}
//                     </div>
//                 );
//             case 'line':
//                 return <div style={style} />;
//             case 'image':
//                 return element.content ? (
//                     <img 
//                         src={element.content} 
//                         alt="Company" 
//                         style={style} 
//                     />
//                 ) : (
//                     <img 
//                         src={companyDetails.img} 
//                         alt="Company" 
//                         style={style} 
//                     />
//                 );
//             default:
//                 return null;
//         }
//     };

//     // Render default bill (your original bill design)
//     const renderDefaultBill = () => {
//         return (
//             <div className='printCustomClassContainer w-full h-full flex flex-col p-10 gap-3 overflow-x-hidden overflow-y-auto customScroll'>
//                 <div className='w-full h-max flex justify-center items-center'>
//                     <img className='w-[5rem] h-[5rem]' src={companyDetails.img} alt="" />
//                 </div>
//                 <div className='w-full h-max flex flex-col justify-center items-center font-[600]'>
//                     <span className='fontSizeClass headWeight'>SHERDINE</span>
//                     <span className='fontSizeClass headWeight'>PERINTHALMANNA</span>
//                     <span className='fontSizeClass headWeight'>GST No M43010G195260</span>
//                 </div>
//                 <div className='w-full h-max flex gap-1 text-center justify-center items-center'>
//                     <div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
//                     <span className='fontSizeClass highFontWeight'>INVOICE</span>
//                     <div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
//                 </div>
//                 <div className='printCustomClassContainerInfo w-full h-max flex text-[.9rem]'>
//                     <div className='w-full flex flex-col text-left'>
//                         <span className='fontSizeClass'>Name : <span className='highFontWeight'>Gopu</span></span>
//                         <span className='fontSizeClass'>Table : <span className='highFontWeight'>#{tableNo}</span></span>
//                         <span className='fontSizeClass'>Cashier : <span className='highFontWeight'>biller</span></span>
//                     </div>
//                     <div className='w-max text-nowrap flex flex-col text-left'>
//                         <span className='fontSizeClass w-full flex gap-1'>
//                             <span className='w-full'>Invoice No : </span>
//                             <span className='w-max highFontWeight'>369</span>
//                         </span>
//                         <span className='fontSizeClass w-full flex gap-1'>
//                             <span className='w-full'>Time : </span>
//                             <span className='w-max highFontWeight'>{getCurrentTime()}</span>
//                         </span>
//                         <span className='fontSizeClass w-full flex gap-1'>
//                             <span className='w-full'>Date : </span>
//                             <span className='w-max highFontWeight'>{getCurrentDate()}</span>
//                         </span>
//                     </div>
//                 </div>
//                 <div className='w-full flex flex-col'>
//                     <div className='w-full printCustomClassContainerBorderY flex border-y-2 border-dashed border-[#b6b6b6] font-[600]'>
//                         <div className='w-6/12 py-2 fontSizeClass '>Item</div>
//                         <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Price</div>
//                         <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Qty</div>
//                         <div className='w-2/12 py-2 flex justify-end items-center fontSizeClass '>Total</div>
//                     </div>
//                     <div className='w-full flex flex-col pb-1 border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
//                         {previousSelectedItems.map((item, index) => {
//                             const hasVariant = item.variantName || null
//                             return (
//                                 <div key={index} className='w-full flex'>
//                                     <div className=' text-wrap w-6/12 py-2 fontSizeClass paddingYForItems'>{hasVariant ? `${item.productName} ${item.variantName}` : item.productName}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>₹ {item.rate}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>{item.quantity}</div>
//                                     <div className='w-2/12 py-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>₹ {item.quantity * item.rate}</div>
//                                 </div>
//                             )
//                         })}
//                         {toIncludeAddonsToPrint.map((addon, index) => {
//                             return (
//                                 <div key={index} className='w-full flex text-nowrap'>
//                                     <div className='w-6/12 py-2 fontSizeClass paddingYForItems'>{addon.addonName}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>₹ {addon.rate}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>{addon.quantity}</div>
//                                     <div className='w-2/12 py-2 flex justify-end items-center fontSizeClass paddingYForItems'>₹ {addon.quantity * addon.rate}</div>
//                                 </div>
//                             )
//                         })}
//                     </div>
//                 </div>
//                 <div className='w-full h-max flex flex-col gap-3 text-nowrap border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
//                     <div className='w-full flex flex-col gap-2 gapY'>
//                         <div className='w-full flex'>
//                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>Sub-Total :</span>
//                             <span className='w-4/12 flex justify-end items-center'>
//                                 <span className='w-full text-center'></span>
//                                 <span className='w-max pl-2 text-left fontSizeClass '>₹ {total}</span>
//                             </span>
//                         </div>
//                         <div className='w-full flex'>
//                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>CGST :</span>
//                             <span className='w-4/12 flex justify-end items-center'>
//                                 <span className='w-1/2 text-center fontSizeClass '>0%</span>
//                                 <span className='w-1/2 pl-2 text-right fontSizeClass '>₹ 0</span>
//                             </span>
//                         </div>
//                         <div className='w-full flex'>
//                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>SGST :</span>
//                             <span className='w-4/12 flex justify-end items-center'>
//                                 <span className='w-1/2 text-center fontSizeClass '>0%</span>
//                                 <span className='w-1/2 pl-2 text-right fontSizeClass '>₹ 0</span>
//                             </span>
//                         </div>
//                     </div>
//                     <div className='w-full flex text-nowrap'>
//                         <div className='w-1/2'></div>
//                         <div className='w-1/2 printCustomClassContainerBorderTop flex py-3 border-t-2 border-dashed border-[#b6b6b6]'>
//                             <span className='w-1/3 flex justify-end items-center font-[600] text-[1.05rem] fontSizeClass '>Total :</span>
//                             <span className='w-2/3 flex justify-end items-center'>
//                                 <span className='w-full text-center'></span>
//                                 <span className='w-max pl-2 text-left fontSizeClass'>₹ {total}</span>
//                             </span>
//                         </div>
//                     </div>
//                     <div className='w-full h-max flex flex-col justify-center items-center font-[600]'>
//                         Thank You .... Visit Again 
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     return (
//         <div className='relative w-[30rem] printCustomClass h-full flex items-end bg-[#fff] font-nunito' ref={printRef}>
//             <div className='absolute top-0 right-0 transform translate-x-full pl-2 flex flex-col gap-2 printButton'>
//                 <button className='p-2 cursor-pointer flex justify-center items-center bg-[#fff]' onClick={() => {
//                     onClose(false)
//                     if (orderToKot) {
//                         toast.success("Kot proccessed!", {
//                             className: 'custom-toast',
//                             bodyClassName: 'custom-toast-container',
//                             closeButtonClassName: 'custom-toast-close-button',
//                             onClose: () => { }
//                         });
//                         navigate('/TableView')
//                     }
//                 }}>
//                     <img className='w-[1.5rem]' src={close} alt="" />
//                 </button>

//                 {/* Design Mode Toggle Button */}
//                 <button 
//                     className='p-2 cursor-pointer hover:bg-[#cddcfc] bg-blue-500 text-white rounded'
//                     onClick={() => setDesignMode(!designMode)}
//                 >
//                     {designMode ? 'Exit Design' : 'Design Bill'}
//                 </button>

//                 <div className='bg-[#fff] flex justify-center items-center'>
//                     <ReactToPrint
//                         trigger={() => (
//                             <button
//                                 className="p-2 cursor-pointer hover:bg-[#cddcfc]"
//                             >
//                                 <img className='w-[2rem]' src={print} alt="" />
//                             </button>
//                         )}
//                         content={() => printRef.current}
//                         onAfterPrint={handlePrintBill}
//                         onPrintError={() => {
//                             alert("Print error! Please try again.");
//                         }}
//                     />
//                 </div>
//             </div>

//             {designMode ? (
//                 <BillDesigner 
//                     onSaveDesign={handleSaveDesign}
//                     initialDesign={billDesign}
//                 />
//             ) : (
//                 renderDesignedBill()
//             )}
//         </div>
//     )
// }

// export default PrintBill;

// import React, { useState, useRef, useEffect, useContext } from 'react';
// import BillDesigner from './InvoiceDesigner/BillDesigner';
// import ReactToPrint from "react-to-print";
// // import React, { useState, useRef, useEffect, useContext } from 'react'
// // import ReactToPrint from "react-to-print";
// import print from "./images/icons/icons8-print-100.png"
// import ss from './images/login/ss_Logo.png'
// import close from './images/Inventory/close (1).png'
// import { DBContext } from './DBContext'
// import { ToastContainer, toast } from 'react-toastify';
// import { useLocation, useNavigate } from 'react-router-dom'
// // import {ipcRenderer} from 'electron'
// import io from 'socket.io-client';

// function PrintBill({ onClose, tableNo, area_id, table, billNo, previousSelectedItems, toIncludeAddonsToPrint, total, orderToKot }) {

//     const api_base_url = process.env.REACT_APP_API_BASE_URL

//     const { logginedDB, customerCode, userType, companyDetails, handleGetCompanyDetails } = useContext(DBContext);

//     const navigate = useNavigate(null)

//     function getCurrentDate() {
//         const today = new Date();
//         const day = String(today.getDate()).padStart(2, '0');
//         const month = String(today.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
//         const year = today.getFullYear();
//         return `${day}/${month}/${year}`;
//     }

//     function getCurrentTime() {
//         const today = new Date();
//         const hours = String(today.getHours()).padStart(2, '0');
//         const minutes = String(today.getMinutes()).padStart(2, '0');
//         return `${hours}:${minutes}`;
//     }

//     useEffect(() => {
//         const socket = io(api_base_url, {
//             transports: ['websocket'], // Force WebSocket to avoid fallback issues
//         });

//         socket.on('updateCompany', handleGetCompanyDetails);

//         return () => {
//             socket.off('updateCompany', handleGetCompanyDetails);
//             socket.disconnect();
//         };
//     }, []);

//     const printRef = useRef(null);

//     const handlePrintBill = async () => {

//         try {
//             const response = await fetch(`${api_base_url}/printBill/${logginedDB}/${tableNo}/${area_id}/${table}/${billNo}`, {
//                 method: 'POST'
//             });

//             if (response.ok) {
//                 const data = await response.json()
//                 // //(data);

//                 if (data.runningKotIsThere) {
//                     toast.success("Printed success!", {
//                         className: 'custom-toast',
//                         bodyClassName: 'custom-toast-container',
//                         closeButtonClassName: 'custom-toast-close-button',
//                         onClose: () => { }
//                     });
//                     onClose(false)
//                 } else {
//                     toast.success("Printed success!", {
//                         className: 'custom-toast',
//                         bodyClassName: 'custom-toast-container',
//                         closeButtonClassName: 'custom-toast-close-button',
//                         onClose: () => { }
//                     });
//                     navigate('/TableView')
//                 }
//             } else {
//                 console.error("Error in API call:", response.status);
//             }
//         } catch (error) {
//             console.error("Fetch Error:", error);
//         }

//     }

//     const handleAfterPrint = () => {
//     }
//     return (
//         <div className='relative w-[30rem] printCustomClass h-full flex items-end bg-[#fff] font-nunito' ref={printRef}>
//             <div className='absolute top-0 right-0 transform translate-x-full pl-2 flex flex-col gap-2 printButton'>blaa
//                 <button className='p-2 cursor-pointer flex justify-center items-center bg-[#fff]' onClick={() => {
//                     onClose(false)
//                     if (orderToKot) {
//                         toast.success("Kot proccessed!", {
//                             className: 'custom-toast',
//                             bodyClassName: 'custom-toast-container',
//                             closeButtonClassName: 'custom-toast-close-button',
//                             onClose: () => { }
//                         });
//                         navigate('/TableView')
//                     }
//                 }}>
//                     <img className='w-[1.5rem]' src={close} alt="" />
//                 </button>
//                 <div className='bg-[#fff] flex justify-center items-center'>
//                     <ReactToPrint
//                         trigger={() => (
//                             <button
//                                 className="p-2 cursor-pointer hover:bg-[#cddcfc]"
//                             >
//                                 <img className='w-[2rem]' src={print} alt="" />
//                             </button>
//                         )}
//                         content={() => printRef.current}
//                         onAfterPrint={handlePrintBill}
//                         onPrintError={() => {
//                             alert("Print error! Please try again.");
//                         }}
//                     />
//                 </div>
//             </div>
//             <div className='printCustomClassContainer w-full h-full flex flex-col p-10 gap-3 overflow-x-hidden overflow-y-auto customScroll'>
//                 <div className='w-full h-max flex justify-center items-center'>
//                     <img className='w-[5rem] h-[5rem]' src={companyDetails.img} alt="" />
//                 </div>
//                 <div className='w-full h-max flex flex-col justify-center items-center font-[600]'>
//                     <span className='fontSizeClass headWeight'>SHERDINE</span>
//                     <span className='fontSizeClass headWeight'>PERINTHALMANNA</span>
//                     <span className='fontSizeClass headWeight'>GST No M43010G195260</span>
//                 </div>
//                 <div className='w-full h-max flex gap-1 text-center justify-center items-center'>
//                     <div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
//                     <span className='fontSizeClass highFontWeight'>INVOICE</span>
//                     <div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
//                 </div>
//                 <div className='printCustomClassContainerInfo w-full h-max flex text-[.9rem]'>
//                     <div className='w-full flex flex-col text-left'>
//                         <span className='fontSizeClass'>Name : <span className='highFontWeight'>Gopu</span></span>
//                         <span className='fontSizeClass'>Table : <span className='highFontWeight'>#{tableNo}</span></span>
//                         <span className='fontSizeClass'>Cashier : <span className='highFontWeight'>biller</span></span>
//                     </div>
//                     <div className='w-max text-nowrap flex flex-col text-left'>
//                         <span className='fontSizeClass w-full flex gap-1'>
//                             <span className='w-full'>Invoice No : </span>
//                             <span className='w-max highFontWeight'>369</span>
//                         </span>
//                         <span className='fontSizeClass w-full flex gap-1'>
//                             <span className='w-full'>Time : </span>
//                             <span className='w-max highFontWeight'>{getCurrentTime()}</span>
//                         </span>
//                         <span className='fontSizeClass w-full flex gap-1'>
//                             <span className='w-full'>Date : </span>
//                             <span className='w-max highFontWeight'>{getCurrentDate()}</span>
//                         </span>
//                     </div>
//                 </div>
//                 <div className='w-full flex flex-col'>
//                     <div className='w-full printCustomClassContainerBorderY flex border-y-2 border-dashed border-[#b6b6b6] font-[600]'>
//                         <div className='w-6/12 py-2 fontSizeClass '>Item</div>
//                         <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Price</div>
//                         <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Qty</div>
//                         <div className='w-2/12 py-2 flex justify-end items-center fontSizeClass '>Total</div>
//                     </div>
//                     <div className='w-full flex flex-col pb-1 border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
//                         {previousSelectedItems.map((item, index) => {
//                             const hasVariant = item.variantName || null
//                             return (
//                                 <div key={index} className='w-full flex'>
//                                     <div className=' text-wrap w-6/12 py-2 fontSizeClass paddingYForItems'>{hasVariant ? `${item.productName} ${item.variantName}` : item.productName}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>₹ {item.rate}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>{item.quantity}</div>
//                                     <div className='w-2/12 py-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>₹ {item.quantity * item.rate}</div>
//                                 </div>
//                             )
//                         })}
//                         {toIncludeAddonsToPrint.map((addon, index) => {
//                             return (
//                                 <div key={index} className='w-full flex text-nowrap'>
//                                     <div className='w-6/12 py-2 fontSizeClass paddingYForItems'>{addon.addonName}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>₹ {addon.rate}</div>
//                                     <div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>{addon.quantity}</div>
//                                     <div className='w-2/12 py-2 flex justify-end items-center fontSizeClass paddingYForItems'>₹ {addon.quantity * addon.rate}</div>
//                                 </div>
//                             )
//                         })}
//                     </div>
//                 </div>
//                 <div className='w-full h-max flex flex-col gap-3 text-nowrap border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
//                     <div className='w-full flex flex-col gap-2 gapY'>
//                         <div className='w-full flex'>
//                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>Sub-Total :</span>
//                             <span className='w-4/12 flex justify-end items-center'>
//                                 <span className='w-full text-center'></span>
//                                 <span className='w-max pl-2 text-left fontSizeClass '>₹ {total}</span>
//                             </span>
//                         </div>
//                         <div className='w-full flex'>
//                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>CGST :</span>
//                             <span className='w-4/12 flex justify-end items-center'>
//                                 <span className='w-1/2 text-center fontSizeClass '>0%</span>
//                                 <span className='w-1/2 pl-2 text-right fontSizeClass '>₹ 0</span>
//                             </span>
//                         </div>
//                         <div className='w-full flex'>
//                             <span className='w-8/12 flex justify-end items-center font-[600] fontSizeClass highFontWeight'>SGST :</span>
//                             <span className='w-4/12 flex justify-end items-center'>
//                                 <span className='w-1/2 text-center fontSizeClass '>0%</span>
//                                 <span className='w-1/2 pl-2 text-right fontSizeClass '>₹ 0</span>
//                             </span>
//                         </div>
//                     </div>
//                     <div className='w-full flex text-nowrap'>
//                         <div className='w-1/2'></div>
//                         <div className='w-1/2 printCustomClassContainerBorderTop flex py-3 border-t-2 border-dashed border-[#b6b6b6]'>
//                             <span className='w-1/3 flex justify-end items-center font-[600] text-[1.05rem] fontSizeClass '>Total :</span>
//                             <span className='w-2/3 flex justify-end items-center'>
//                                 <span className='w-full text-center'></span>
//                                 <span className='w-max pl-2 text-left fontSizeClass'>₹ {total}</span>
//                             </span>

//                         </div>
//                     </div>
//                     <div className='w-full h-max flex flex-col justify-center items-center font-[600]'>
//                         Thank You .... Visit Again 
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default PrintBill

// PrintBill.jsx - Updated version
// import React, { useState, useRef, useEffect, useContext } from 'react';
// import ReactToPrint from "react-to-print";
// import print from "./images/icons/icons8-print-100.png"
// import close from './images/Inventory/close (1).png'
// import { DBContext } from './DBContext'
// import { ToastContainer, toast } from 'react-toastify';
// import { useLocation, useNavigate } from 'react-router-dom'
// import io from 'socket.io-client';
// import BillDesignRenderer from './InvoiceDesigner/BillDesignRenderer'; // You'll create this

// function PrintBill({ onClose, tableNo, area_id, table, billNo, previousSelectedItems, toIncludeAddonsToPrint, total, orderToKot }) {
//     const api_base_url = process.env.REACT_APP_API_BASE_URL
//     const { logginedDB, customerCode, userType, companyDetails, handleGetCompanyDetails } = useContext(DBContext);
//     const navigate = useNavigate(null);
//     const printRef = useRef(null);
//     const [design, setDesign] = useState(null);

//     // Load saved design from localStorage
//     useEffect(() => {
//         const savedDesign = localStorage.getItem('billDesign');
//         if (savedDesign) {
//             setDesign(JSON.parse(savedDesign));
//         }
//     }, []);

//     // Prepare dynamic data for the bill
//     const getCurrentDate = () => {
//         const today = new Date();
//         const day = String(today.getDate()).padStart(2, '0');
//         const month = String(today.getMonth() + 1).padStart(2, '0');
//         const year = today.getFullYear();
//         return `${day}/${month}/${year}`;
//     };

//     const getCurrentTime = () => {
//         const today = new Date();
//         const hours = String(today.getHours()).padStart(2, '0');
//         const minutes = String(today.getMinutes()).padStart(2, '0');
//         return `${hours}:${minutes}`;
//     };

//     // Calculate GST (example logic - adjust based on your needs)
//     const calculateGST = (subtotal) => {
//         // Example: 5% CGST and 5% SGST
//         const gstRate = 5; // percentage
//         const gstAmount = (subtotal * gstRate) / 100;
//         return {
//             cgst: gstAmount,
//             sgst: gstAmount,
//             total: subtotal + (2 * gstAmount)
//         };
//     };

//     // Prepare dynamic data object
//     const dynamicData = {
//         invoiceNumber: billNo || "369",
//         customerName: "Gopu", // You might want to make this dynamic
//         tableNumber: tableNo || "#4",
//         date: getCurrentDate(),
//         time: getCurrentTime(),
//         cashier: "biller",
//         waiter: "John Doe", // Add waiter name if available
//         items: previousSelectedItems.map(item => ({
//             name: item.variantName ? `${item.productName} ${item.variantName}` : item.productName,
//             price: item.rate,
//             quantity: item.quantity,
//             total: item.quantity * item.rate
//         })),
//         addons: toIncludeAddonsToPrint.map(addon => ({
//             name: addon.addonName,
//             price: addon.rate,
//             quantity: addon.quantity,
//             total: addon.quantity * addon.rate
//         })),
//         subtotal: total,
//         gst: calculateGST(total),
//         grandTotal: total + (calculateGST(total).cgst + calculateGST(total).sgst),
//         companyInfo: {
//             name: companyDetails?.name || logginedDB || "",
//             address: companyDetails?.add1 || "",
//             phone: companyDetails?.mobile || "",
//             email: companyDetails?.email || "",
//             gst: companyDetails?.gst || "",
//             logo: companyDetails?.img || ""
//         }
//     };

//     const handlePrintBill = async () => {
//         try {
//             const response = await fetch(`${api_base_url}/printBill/${logginedDB}/${tableNo}/${area_id}/${table}/${billNo}`, {
//                 method: 'POST'
//             });

//             if (response.ok) {
//                 const data = await response.json();

//                 if (data.runningKotIsThere) {
//                     toast.success("Printed success!", {
//                         className: 'custom-toast',
//                         bodyClassName: 'custom-toast-container',
//                         closeButtonClassName: 'custom-toast-close-button',
//                         onClose: () => { }
//                     });
//                     onClose(false);
//                 } else {
//                     toast.success("Printed success!", {
//                         className: 'custom-toast',
//                         bodyClassName: 'custom-toast-container',
//                         closeButtonClassName: 'custom-toast-close-button',
//                         onClose: () => { }
//                     });
//                     navigate('/TableView');
//                 }
//             } else {
//                 console.error("Error in API call:", response.status);
//             }
//         } catch (error) {
//             console.error("Fetch Error:", error);
//         }
//     };

//     return (
//         <div className='relative w-full h-full bg-white font-nunito'>
//             <div className='absolute top-0 right-0 p-4 flex gap-2 z-10 bg-white shadow-md rounded-bl-lg'>
//                 <button 
//                     className='p-2 cursor-pointer hover:bg-gray-100 rounded'
//                     onClick={() => {
//                         onClose(false);
//                         if (orderToKot) {
//                             toast.success("Kot proccessed!", {
//                                 className: 'custom-toast',
//                                 bodyClassName: 'custom-toast-container',
//                                 closeButtonClassName: 'custom-toast-close-button',
//                                 onClose: () => { }
//                             });
//                             navigate('/TableView');
//                         }
//                     }}
//                 >
//                     <img className='w-6 h-6' src={close} alt="Close" />
//                 </button>

//                 <div className='flex justify-center items-center'>
//                     <ReactToPrint
//                         trigger={() => (
//                             <button className="p-2 cursor-pointer hover:bg-gray-100 rounded">
//                                 <img className='w-8 h-8' src={print} alt="Print" />
//                             </button>
//                         )}
//                         content={() => printRef.current}
//                         onAfterPrint={handlePrintBill}
//                         onPrintError={() => {
//                             alert("Print error! Please try again.");
//                         }}
//                     />
//                 </div>
//             </div>

//             <div ref={printRef} className="w-full h-full p-4">
//                 {design ? (
//                     <BillDesignRenderer 
//                         design={design}
//                         dynamicData={dynamicData}
//                     />
//                 ) : (
//                     // Fallback to original bill design if no custom design
//                     <div className='w-full h-full flex flex-col p-10 gap-3'>
//                         {/* Your original bill HTML here */}
//                         <div className='w-full h-max flex justify-center items-center'>
//                             <img className='w-20 h-20' src={companyDetails.img} alt="Company Logo" />
//                         </div>
//                         <div className='w-full h-max flex flex-col justify-center items-center font-semibold'>
//                             <span className='text-lg font-bold'>{companyDetails?.name || "SHERDINE"}</span>
//                             <span className='text-sm'>{companyDetails?.add1 || "PERINTHALMANNA"}</span>
//                             <span className='text-sm'>GST No {companyDetails?.gst || "M43010G195260"}</span>
//                         </div>
//                         {/* ... rest of your original bill ... */}
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// }

// export default PrintBill;

// components/PrintBill.jsx
import React, { useState, useRef, useEffect, useContext } from 'react';
import ReactToPrint from "react-to-print";
import print from "./images/icons/icons8-print-100.png";
import close from './images/Inventory/close (1).png';
import { DBContext } from './DBContext';
import { ToastContainer, toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import io from 'socket.io-client';
import BillDesignRenderer from './InvoiceDesigner/BillDesignRenderer';
import PaginatedBillRenderer from './PaginatedBillRenderer';

function PrintBill({
    onClose,
    tableNo,
    area_id,
    table,
    billNo,
    previousSelectedItems = [],
    toIncludeAddonsToPrint = [],
    total = 0,
    billAdjustments = null,
    orderToKot,
    customerName = "",
    customerPhone = "",
    customerAddress = "",
    orderType = "",
    cashierName = "",
    waiterName = "",
    genSettings = null,
    taxGroups = []
}) {
    const api_base_url = process.env.REACT_APP_API_BASE_URL;
    const { logginedDB, customerCode, userType, companyDetails, handleGetCompanyDetails } = useContext(DBContext);
    const navigate = useNavigate();
    const printRef = useRef(null);
    const [design, setDesign] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [showOriginal, setShowOriginal] = useState(false);

    // Load saved design from localStorage
    useEffect(() => {
        setIsLoading(true);
        try {
            const savedDesign = localStorage.getItem('billDesign');
            if (savedDesign) {
                const parsedDesign = JSON.parse(savedDesign);
                setDesign(parsedDesign);
            } else {
                setDesign(null);
            }
        } catch (error) {
            console.error("Error loading design:", error);
            setDesign(null);
        } finally {
            setIsLoading(false);
        }
    }, []);

    // Socket connection for real-time updates
    useEffect(() => {
        const socket = io(api_base_url, {
            transports: ['websocket'],
        });

        socket.on('updateCompany', handleGetCompanyDetails);

        return () => {
            socket.off('updateCompany', handleGetCompanyDetails);
            socket.disconnect();
        };
    }, []);

    // Prepare dynamic data for the bill
    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const getCurrentTime = () => {
        const today = new Date();
        const hours = String(today.getHours()).padStart(2, '0');
        const minutes = String(today.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    // Calculate GST based on settings
    const calculateGST = (subtotal) => {
        let rate = 5; // Fallback
        let inclusive = false;
        
        if (genSettings) {
            inclusive = genSettings.isTaxInclusive === 1;
            const defaultTax = (taxGroups || []).find(t => t.id_tax === genSettings.Default_Tax_Id);
            if (defaultTax) {
                rate = defaultTax.gstPercent || 0;
            }
            if (genSettings.Tax_Mode === 'NONE') rate = 0;
        }

        let gstAmount = 0;
        let taxableValue = subtotal;

        if (inclusive) {
            // Tax is already inside subtotal
            // Formula: Tax = Total - (Total / (1 + (Rate/100)))
            gstAmount = subtotal - (subtotal / (1 + (rate / 100)));
            taxableValue = subtotal - gstAmount;
        } else {
            // Tax is added on top
            gstAmount = (subtotal * rate) / 100;
        }

        return {
            cgst: gstAmount / 2,
            sgst: gstAmount / 2,
            taxAmount: gstAmount,
            total: inclusive ? subtotal : (subtotal + gstAmount),
            rate: rate,
            taxableValue: taxableValue,
            inclusive: inclusive
        };
    };

    // Prepare all items
    const allItems = [
        ...(previousSelectedItems || []).map(item => ({
            ...item,
            name: item.variantName ? `${item.productName} ${item.variantName}` : item.productName,
            total: item.quantity * item.rate,
            isAddon: false
        })),
        ...(toIncludeAddonsToPrint || []).map(addon => ({
            ...addon,
            name: addon.addonName,
            total: addon.quantity * addon.rate,
            isAddon: true
        }))
    ];

    const formatMoney = (value) => Number(parseFloat(value) || 0).toFixed(2);
    const hasBillAdjustments = !!billAdjustments;
    const adjustmentRows = hasBillAdjustments ? [
        { label: "Delivery Charge", amount: billAdjustments.deliveryCharge },
        { label: "Container Charge", amount: billAdjustments.containerCharge },
        { label: "Tip", amount: billAdjustments.tip },
    ].filter(row => parseFloat(row.amount) > 0) : [];
    const customerPaid = hasBillAdjustments ? parseFloat(billAdjustments.customerPaid) || 0 : 0;
    const balanceDue = hasBillAdjustments ? parseFloat(billAdjustments.balanceDue) || 0 : 0;
    const balanceReturn = hasBillAdjustments ? parseFloat(billAdjustments.balanceReturn) || 0 : 0;
    const discountAmount = hasBillAdjustments ? parseFloat(billAdjustments.discountAmount) || 0 : 0;
    const taxableSubtotal = hasBillAdjustments ? parseFloat(billAdjustments.baseTotal) || 0 : parseFloat(total) || 0;
    const displaySubtotal = hasBillAdjustments ? taxableSubtotal + discountAmount : taxableSubtotal;
    const calculatedGstData = calculateGST(taxableSubtotal);
    const gstData = hasBillAdjustments ? {
        ...calculatedGstData,
        cgst: parseFloat(billAdjustments.cgst) || calculatedGstData.cgst,
        sgst: parseFloat(billAdjustments.sgst) || calculatedGstData.sgst,
        taxAmount: parseFloat(billAdjustments.totalTax) || calculatedGstData.taxAmount,
    } : calculatedGstData;
    const grandTotal = hasBillAdjustments ? billAdjustments.netTotal : gstData.total;
    const splitTaxRate = formatMoney((parseFloat(gstData.rate) || 0) / 2);

    // Prepare dynamic data object
    const dynamicData = {
        invoiceNumber: billNo || "369",
        customerName: customerName,
        customerPhone: customerPhone,
        customerAddress: customerAddress,
        orderType: orderType,
        tableNumber: tableNo ? `#${tableNo}` : "#4",
        date: getCurrentDate(),
        time: getCurrentTime(),
        cashier: cashierName,
        waiter: waiterName,
        items: allItems.filter(item => !item.isAddon),
        addons: allItems.filter(item => item.isAddon),
        subtotal: formatMoney(displaySubtotal),
        billAdjustments: {
            rows: adjustmentRows.map(row => ({
                ...row,
                amount: formatMoney(row.amount)
            })),
            discountAmount: formatMoney(discountAmount),
            customerPaid: formatMoney(customerPaid),
            balanceDue: formatMoney(balanceDue),
            balanceReturn: formatMoney(balanceReturn),
            netTotal: formatMoney(grandTotal),
            hasAdjustments: hasBillAdjustments
        },
        gst: {
            ...gstData,
            cgst: formatMoney(gstData.cgst),
            sgst: formatMoney(gstData.sgst),
            splitRate: splitTaxRate
        },
        grandTotal: formatMoney(grandTotal),
        companyInfo: {
            name: companyDetails?.name || logginedDB || "SHERDINE",
            address: companyDetails?.add1 || "PERINTHALMANNA",
            phone: companyDetails?.mobile || "",
            email: companyDetails?.email || "",
            gst: companyDetails?.gst || "M43010G195260",
            logo: companyDetails?.img || ""
        },
        allItems: allItems
    };
    // console.log("Dynamic Data:", dynamicData);
    const handlePrintBill = async () => {
        try {
            const response = await fetch(`${api_base_url}/printBill/${logginedDB}/${tableNo}/${area_id}/${table}/${billNo}`, {
                method: 'POST'
            });

            if (response.ok) {
                const data = await response.json();

                if (data.runningKotIsThere) {
                    toast.success("Printed successfully!", {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => { }
                    });
                    onClose(false);
                } else {
                    toast.success("Printed successfully!", {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => { }
                    });
                    navigate('/TableView');
                }
            } else {
                console.error("Error in API call:", response.status);
                toast.error("Print failed. Please try again.");
            }
        } catch (error) {
            console.error("Fetch Error:", error);
            toast.error("Print failed. Please check connection.");
        }
    };

    const handleAfterPrint = () => {
        // console.log("Print completed");
    };

    const handlePrintError = (error) => {
        console.error("Print Error:", error);
        toast.error("Print error! Please try again.");
    };

    // Original bill design (fallback)
    const renderOriginalBill = () => {
        return (
            <div className='w-full h-full flex flex-col p-8 gap-3 shrink-0 print:py-4 print:px-2'>
                {/* Company Logo */}
                <div className='w-full h-max flex justify-center items-center'>
                    {companyDetails?.img ? (
                        <img
                            className='w-16 h-16 object-contain print:w-14 print:h-14'
                            src={companyDetails.img}
                            alt="Company Logo"
                        />
                    ) : (
                        <div className='w-16 h-16 flex items-center justify-center bg-gray-100 rounded border'>
                            <span className='text-xs text-gray-500'>Logo</span>
                        </div>
                    )}
                </div>

                {/* Company Info */}
                <div className='w-full h-max flex flex-col justify-center items-center font-semibold text-center'>
                    <span className='text-base font-bold print:text-sm'>{dynamicData.companyInfo.name}</span>
                    <span className='text-sm print:text-xs'>{dynamicData.companyInfo.address}</span>
                    <span className='text-sm print:text-xs'>GST No: {dynamicData.companyInfo.gst}</span>
                </div>

                {/* Invoice Header */}
                <div className='w-full h-max flex gap-2 text-center justify-center items-center'>
                    <div className="w-full h-[1px] border-t-2 border-dashed border-gray-400" />
                    <span className='text-lg font-bold print:text-base'>INVOICE</span>
                    <div className="w-full h-[1px] border-t-2 border-dashed border-gray-400" />
                </div>

                {/* Invoice Details */}
                <div className='w-full flex text-sm print:text-xs'>
                    <div className='w-1/2 flex flex-col text-left gap-1'>
                        <span>Name: <span className='font-semibold'>{dynamicData.customerName}</span></span>
                        {dynamicData.customerPhone && (
                            <span>Phone: <span className='font-semibold'>{dynamicData.customerPhone}</span></span>
                        )}
                        {dynamicData.orderType === 'delivery' && dynamicData.customerAddress && (
                            <span>Address: <span className='font-semibold'>{dynamicData.customerAddress}</span></span>
                        )}
                        <span>Table: <span className='font-semibold'>{dynamicData.tableNumber}</span></span>
                        <span>Cashier: <span className='font-semibold'>{dynamicData.cashier}</span></span>
                        <span>Waiter: <span className='font-semibold'>{dynamicData.waiter}</span></span>
                    </div>
                    <div className='w-1/2 flex flex-col text-right gap-1'>
                        <span>Invoice No: <span className='font-semibold'>{dynamicData.invoiceNumber}</span></span>
                        <span>Time: <span className='font-semibold'>{dynamicData.time}</span></span>
                        <span>Date: <span className='font-semibold'>{dynamicData.date}</span></span>
                    </div>
                </div>

                {/* Items Table */}
                <div className='w-full flex flex-col border-t border-b border-gray-300'>
                    {/* Table Header */}
                    <div className='w-full flex font-semibold border-b border-gray-300 py-2'>
                        <div className='w-1/2 text-left pl-2'>Item</div>
                        <div className='w-1/6 text-right'>Price</div>
                        <div className='w-1/6 text-right'>Qty</div>
                        <div className='w-1/6 text-right pr-2'>Total</div>
                    </div>

                    {/* Table Rows */}
                    {allItems.map((item, index) => (
                        <div key={index} className='w-full flex py-1 border-b border-gray-100'>
                            <div className="w-1/2 print:w-[40%] truncate">{item.name}</div>
                            <div className="w-1/6 print:w-[20%] text-right">₹ {item.price}</div>
                            <div className="w-1/6 print:w-[20%] text-right">{item.quantity}</div>
                            <div className="w-1/6 print:w-[20%] text-right">₹ {item.total}</div>
                        </div>
                    ))}

                    {allItems.length === 0 && (
                        <div className='w-full py-4 text-center text-gray-500'>
                            No items
                        </div>
                    )}
                </div>

                {/* Totals */}
                <div className='w-full flex flex-col gap-2'>
                    <div className='w-full flex justify-end'>
                        <div className='w-1/2 flex flex-col gap-1'>
                            <div className='flex justify-between'>
                                <span>Sub-Total:</span>
                                <span>₹ {dynamicData.subtotal}</span>
                            </div>
                            {dynamicData.billAdjustments.rows.map((row, index) => (
                                <div className='flex justify-between' key={index}>
                                    <span>{row.label}:</span>
                                    <span>₹ {row.amount}</span>
                                </div>
                            ))}
                            {parseFloat(dynamicData.billAdjustments.discountAmount) > 0 && (
                                <div className='flex justify-between'>
                                    <span>Discount:</span>
                                    <span>-₹ {dynamicData.billAdjustments.discountAmount}</span>
                                </div>
                            )}
                            <div className='flex justify-between'>
                                <span>CGST ({dynamicData.gst.splitRate}%):</span>
                                <span>₹ {dynamicData.gst.cgst}</span>
                            </div>
                            <div className='flex justify-between'>
                                <span>SGST ({dynamicData.gst.splitRate}%):</span>
                                <span>₹ {dynamicData.gst.sgst}</span>
                            </div>
                            <div className='flex justify-between font-bold border-t border-gray-300 pt-1 mt-1'>
                                <span>Grand Total:</span>
                                <span>₹ {dynamicData.grandTotal}</span>
                            </div>
                            {parseFloat(dynamicData.billAdjustments.customerPaid) > 0 && (
                                <div className='flex justify-between'>
                                    <span>Customer Paid:</span>
                                    <span>₹ {dynamicData.billAdjustments.customerPaid}</span>
                                </div>
                            )}
                            {parseFloat(dynamicData.billAdjustments.balanceReturn) > 0 && (
                                <div className='flex justify-between font-bold'>
                                    <span>Balance Return:</span>
                                    <span>₹ {dynamicData.billAdjustments.balanceReturn}</span>
                                </div>
                            )}
                            {parseFloat(dynamicData.billAdjustments.balanceDue) > 0 && (
                                <div className='flex justify-between font-bold'>
                                    <span>Balance Due:</span>
                                    <span>₹ {dynamicData.billAdjustments.balanceDue}</span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Footer */}
                    <div className='w-full text-center pt-4 border-t border-dashed border-gray-300'>
                        <div className='font-semibold text-sm'>Thank You for Your Visit!</div>
                        <div className='text-xs text-gray-500'>Please visit again</div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className='fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50 p-4'>
            <div className='relative bg-white rounded-lg shadow-xl w-full max-w-[1024px] max-h-[90vh] overflow-hidden flex flex-col'>
                {/* Header */}
                <div className='flex justify-between items-center p-4 border-b bg-white'>
                    <h2 className='text-xl font-bold text-gray-800'>Print Bill</h2>
                    <div className='flex gap-2'>
                        <button
                            onClick={() => setShowOriginal(!showOriginal)}
                            className={`px-3 py-1.5 text-sm rounded ${showOriginal ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`}
                        >
                            {showOriginal ? 'Show Designed' : 'Show Original'}
                        </button>

                        <ReactToPrint
                            trigger={() => (
                                <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center gap-2">
                                    <img className='w-5 h-5' src={print} alt="Print" />
                                    <span>Print</span>
                                </button>
                            )}
                            content={() => printRef.current}
                            onAfterPrint={handlePrintBill}
                            onPrintError={handlePrintError}
                        />

                        <button
                            className='p-2 cursor-pointer hover:bg-gray-100 rounded'
                            onClick={() => {
                                onClose(false);
                                if (orderToKot) {
                                    toast.success("KOT processed!", {
                                        className: 'custom-toast',
                                        bodyClassName: 'custom-toast-container',
                                        closeButtonClassName: 'custom-toast-close-button',
                                    });
                                    navigate('/TableView');
                                }
                            }}
                        >
                            <img className='w-6 h-6' src={close} alt="Close" />
                        </button>
                    </div>
                </div>

                {/* Loading State */}
                {isLoading ? (
                    <div className="flex-1 flex items-center justify-center">
                        <div className="text-center">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
                            <p className="mt-4 text-gray-600">Loading bill design...</p>
                        </div>
                    </div>
                ) : (
                    // <div className="flex-1 overflow-auto p-4">
                    //     <div ref={printRef} className="print-container">
                    <div className="flex-1 overflow-auto p-4 flex justify-center">
                        <div
                            ref={printRef}
                            className="
                                bg-white
                                w-[720px]
                                min-w-[720px]
                                shrink-0
                                print:w-[80mm]
                                print:min-w-[80mm]
                                print:overflow-visible
                                "
                        >
                            {design && !showOriginal && dynamicData ? (
                                <div className="flex flex-col items-center">
                                    <BillDesignRenderer
                                        design={design}
                                        dynamicData={dynamicData}
                                    />

                                    <div className="mt-4 text-sm text-gray-500 text-center print:hidden">
                                        Custom bill design loaded
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    {renderOriginalBill()}
                                    <div className="mt-4 text-sm text-gray-500 text-center print:hidden">
                                        {
                                            design ?
                                                'No dynamic data available'
                                                :
                                                'Using original bill design'
                                        }
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Footer Info */}
                <div className="p-3 border-t bg-gray-50 text-xs text-gray-500 print:hidden">
                    <div className="flex justify-between">
                        <span>Items: {allItems.length} | Subtotal: ₹{total}</span>
                        <span>Design: {design ? 'Custom' : 'Default'}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrintBill;
